// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainDisplayTabs_mainDisplayTabsContainer__1xZmM {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow: hidden;
    flex-grow: 1;
    min-width: 0;  /* flex 자식의 default min-width:auto 해제 — 자식 ResultGrid 가 가로로 부모를 뚫지 않도록. */
}

/* 탭 종류 아이콘 — 통합 헤더에서 결과/실행계획/오브젝트 구분. */
.MainDisplayTabs_subTabKindIcon__e3ee3 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 4px 0 2px;
    color: var(--color-text-muted, #6b7280);
    flex-shrink: 0;
}
.MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V .MainDisplayTabs_subTabKindIcon__e3ee3 {
    color: var(--color-accent, #2563eb);
}

.MainDisplayTabs_mainTabsContentArea__oixj8 { /* .mainTabsContent에서 변경 */
    flex-grow: 1;
    overflow: hidden; /* Prevent this container from scrolling */
    /* 위쪽 여백은 좁게(2026-10-07, 「위쪽 여백을 조금 줄여줘」) — 도구줄 바로 아래라 10px 이면 탭이 떠 보였다 */
    padding: 4px 10px 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    min-height: 0; /* Allow shrinking in flex context */
    min-width: 0;  /* row-direction parent(.mainDisplayTabsContainer) 안에서 가로로 줄어들 수 있게 — 자식 ResultGrid 의 가로 스크롤 동작 보장. */
}

/* 개별 탭 내용에 대한 스타일 (ResultGrid 등은 자체 스타일 가짐) */
.MainDisplayTabs_tabContent__n-Lr6 {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    /* 예를 들어 ResultGrid는 내부적으로 스크롤을 처리하므로, 여기서는 flex 설정만으로 충분할 수 있음 */
}

/* 하위 탭 (쿼리 결과 탭 내부) */
.MainDisplayTabs_subTabsContainer__SPQfO {
    display: flex;
    flex-direction: column;
    /* 남은 높이만 쓴다. height:100% 이면 위의 탭 머리줄 높이만큼 넘쳐서, 부모의 overflow:hidden 에
       표 아래쪽(가로 스크롤바)이 잘렸다(신고 2026-10-01). */
    flex: 1 1;
    min-height: 0;
    min-width: 0;
}

/* 결과 탭 헤더 — 에디터 탭(.tabsContainer) 과 동일한 톤 (var(--color-tab-bg)).
   상단에 padding 두어 탭 컨테이너가 약간 떠있는 듯한 효과. */
.MainDisplayTabs_subTabsHeader__zYO8K {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-shrink: 0;
    border-bottom: 1px solid var(--color-border, #ddd);
    background-color: var(--color-tab-bg, #f0f0f0);
    padding: 3px 5px 0 5px;
    overflow: hidden;
    box-sizing: border-box;
}

.MainDisplayTabs_tabButtonsArea__tbty6 {
    display: flex;
    flex-grow: 1;
    /* 줄어드는 것은 이 칸(가로 스크롤)이지 탭 하나하나가 아니다 — 탭이 눌리면 안의 「중지」·「모니터링」 글자가 접혀
       탭 머리가 두 배로 높아졌다(2026-10-29 신고: 실행 중에만 줄바꿈된 채 유지) */
    min-width: 0;
    overflow-x: auto; /* 탭이 많아지면 가로 스크롤 */
    overflow-y: hidden;
}

.MainDisplayTabs_tabActionsArea__AT5mr {
    display: flex;
    gap: 8px;
    padding: 2px 10px;
    flex-shrink: 0;
    /* 왼쪽 구분선 없이 머리줄과 같은 배경 한 장(2026-10-07) */
    background-color: transparent;
    align-items: center;
}

/* 결과탭 액션 버튼 (전체출력/CSV저장) — 중립적인 회색 톤. 청색 채움 대신 outline+
   subtle bg 로 톤 다운. 헤더 다른 요소들과 시각적으로 충돌하지 않게. */
.MainDisplayTabs_actionButton__qul1G {
    padding: 3px 10px;
    border: 1px solid #c0c0c0;
    background-color: #f5f5f5;
    color: #333;
    border-radius: 4px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
}

.MainDisplayTabs_actionButton__qul1G:hover:not(:disabled) {
    background-color: #e0e0e0;
    border-color: #999;
    color: #000;
}

.MainDisplayTabs_actionButton__qul1G:disabled {
    background-color: #f5f5f5;
    border-color: #d4d4d4;
    color: #aaa;
    cursor: not-allowed;
    opacity: 0.7;
}

/* 다크모드 — actionButton 도 동일한 중립 톤. */
[data-theme="dark"] .MainDisplayTabs_actionButton__qul1G {
    background-color: var(--color-bg-tertiary);
    border-color: var(--color-border);
    color: var(--color-text);
}
[data-theme="dark"] .MainDisplayTabs_actionButton__qul1G:hover:not(:disabled) {
    background-color: var(--color-hover);
    border-color: var(--color-text-muted);
    color: var(--color-text);
}
[data-theme="dark"] .MainDisplayTabs_actionButton__qul1G:disabled {
    background-color: var(--color-bg-secondary);
    border-color: var(--color-border);
    color: var(--color-text-muted);
}

/* 다크모드 — stopButton (위험 액션, 중지) */
[data-theme="dark"] .MainDisplayTabs_stopButton__qE9ey {
    background-color: #c0303f;
    border-color: #c0303f;
    color: #fff;
}
[data-theme="dark"] .MainDisplayTabs_stopButton__qE9ey:hover {
    background-color: #a52833;
    border-color: #a52833;
}

.MainDisplayTabs_stopButton__qE9ey {
    padding: 6px 12px;
    border: 1px solid #dc3545;
    background-color: #dc3545;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    transition: background-color 0.2s, border-color 0.2s;
    margin-right: 8px;
}

.MainDisplayTabs_stopButton__qE9ey:hover {
    background-color: #c82333;
    border-color: #c82333;
}

.MainDisplayTabs_subTabButton__W5txA {
    padding: 4px 4px 4px 3px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-family: var(--font-ui, 'Segoe UI', sans-serif);
    font-size: var(--font-size-tab, 12px);
    outline: none;
    white-space: nowrap;
    flex-grow: 0;
    min-width: 0;
    text-align: left;
    color: #999;
    display: inline-flex;
    align-items: center;
    height: 100%;
    line-height: 1;
}

.MainDisplayTabs_subTabButton__W5txA:last-child {
    border-right: none;
}

.MainDisplayTabs_subTabButton__W5txA.MainDisplayTabs_active__JsB9V {
    background-color: transparent;
    font-weight: 500;
    color: #333;
}


/* 결과 탭 컨테이너 — 에디터 탭(.tabItem) 과 동일한 모양 (border + 상단 둥글기).
   비활성 탭은 회색, 활성 탭은 본문 배경색으로 합쳐져 컨텐츠와 연결된 듯한 느낌.
   padding 으로 높이를 에디터 탭과 비슷하게 (~32px) 유지. */
.MainDisplayTabs_subTabButtonContainer__GAjBB {
    display: flex;
    flex-shrink: 0;
    white-space: nowrap;
    align-items: center;
    padding: 4px 4px;
    background-color: #e9e9e9;
    color: #666;
    border: 1px solid #ccc;
    border-bottom: none;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-right: 1px;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.MainDisplayTabs_subTabButtonContainer__GAjBB:not(.MainDisplayTabs_active__JsB9V):hover {
    background-color: #d4d4d4;
}

.MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V {
    background-color: var(--color-bg, #ffffff);
    color: #333;
    border-color: #ccc;
    border-bottom-color: var(--color-bg, #ffffff); /* 헤더 border-bottom 과 겹쳐 컨텐츠와 연결된 효과 */
    margin-bottom: -1px; /* 헤더 border-bottom 위로 살짝 끌어올림 */
    z-index: 1;
}

.MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V .MainDisplayTabs_subTabButton__W5txA {
    color: #333 !important;
    font-weight: 500 !important;
}

.MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V:hover {
    background-color: var(--color-bg, #fff);
}

/* 결과 탭의 종류 아이콘 = 고정 단추(2026-10-21 — 따로 있던 책갈피 단추를 없앴다). 모양은 .subTabKindIcon 그대로, 고정되면 주황 */
.MainDisplayTabs_kindPinButton__5qxvO {
    background: transparent;
    border: none;
    padding: 2px;
    border-radius: 3px;
    cursor: pointer;
    transition: color 0.16s ease, background-color 0.16s ease;
}
.MainDisplayTabs_kindPinButton__5qxvO:hover {
    color: var(--color-accent, #2563eb);
    background: rgba(37, 99, 235, 0.1);
}
.MainDisplayTabs_kindPinButton__5qxvO.MainDisplayTabs_pinned__3yBs-,
.MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V .MainDisplayTabs_kindPinButton__5qxvO.MainDisplayTabs_pinned__3yBs- {
    color: #ff6b00;
}
.MainDisplayTabs_kindPinButton__5qxvO:focus-visible {
    outline: 2px solid var(--color-accent, #2563eb);
    outline-offset: 1px;
}
@media (prefers-reduced-motion: reduce) {
    .MainDisplayTabs_kindPinButton__5qxvO { transition: none; }
}

.MainDisplayTabs_stopTabButton__m\\+o73 {
    white-space: nowrap;
    flex-shrink: 0;
    background-color: #dc3545;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    padding: 4px 10px;
    margin-left: 6px;
    border-radius: 3px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    white-space: nowrap;
}

.MainDisplayTabs_stopTabButton__m\\+o73:hover {
    background-color: #c82333;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* 닫기 — 편집기 탭의 닫기(FileTabs .closeButton)와 같은 모양: 18px 동그라미, 호버하면 둥근 배경(사용자 요청 2026-10-26) */
.MainDisplayTabs_closeTabButton__xK0\\+i {
    background: transparent;
    border: none;
    color: #777;
    cursor: pointer;
    width: 18px;
    height: 18px;
    padding: 0;
    margin-left: 4px;
    margin-right: 2px;
    line-height: 0;
    border-radius: 50%;
    flex-shrink: 0;
    transition: color 0.2s ease, background-color 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.MainDisplayTabs_closeTabButton__xK0\\+i:hover {
    color: #d32f2f;
    background: rgba(211, 47, 47, 0.12);
}

.MainDisplayTabs_subTabButtonPlaceholder__W1m\\+Q { /* 빈 공간 스타일 이름 변경 또는 기존 스타일 유지 */
    padding: 8px 12px;
    border: none;
    background-color: transparent;
    font-size: 13px;
    white-space: nowrap;
    flex-grow: 1;
}

.MainDisplayTabs_subTabsContent__pyW55 { /* 이 부분이 ResultGrid 등을 직접 포함하는 컨테이너 */
    flex-grow: 1;
    overflow: hidden; /* Prevent this container from scrolling */
    display: flex;
    flex-direction: column;
    min-width: 0;     /* flex 자식의 기본 min-width:auto 해제 — 자식 ResultGrid 가 부모 폭을 뚫고 가로로 늘어나는 것을 방지. */
    /* padding은 필요에 따라 여기에 두거나 ResultGrid 자체에서 처리 */
}

/* 이전에 추가했던 .tabDisplayArea 및 내부 .statusLine 관련 스타일은 제거됨 */

.MainDisplayTabs_noTabsMessage__YSKFA {
    padding: 20px;
    text-align: center;
    color: #777;
    font-style: italic;
}

/* 테이블 정보 탭 내부 스타일 */
.MainDisplayTabs_tabContentLoading__spxjb,
.MainDisplayTabs_tabContentError__lKrBq {
    padding: 20px;
    text-align: center;
    font-style: italic;
}
.MainDisplayTabs_tabContentError__lKrBq {
    color: red;
}

.MainDisplayTabs_tableDetailContent__e2M5F {
    flex-grow: 1;
    overflow: auto; /* 내용 많을 시 스크롤 */
    padding: 10px; /* 테이블 주변 여백 */
}

.MainDisplayTabs_tableDetailContent__e2M5F h4 {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 1.1em;
}

.MainDisplayTabs_infoTable__zX80K {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--font-ui, 'Segoe UI', sans-serif);
    font-size: var(--font-size-grid, 12px);
}

.MainDisplayTabs_infoTable__zX80K th,
.MainDisplayTabs_infoTable__zX80K td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    vertical-align: top;
}

.MainDisplayTabs_infoTable__zX80K th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.MainDisplayTabs_infoTable__zX80K tbody tr:nth-child(even) {
    background-color: #f9f9f9;
}

.MainDisplayTabs_infoTable__zX80K tbody tr:hover {
    background-color: #f1f1f1;
}

/* 실행 계획 탭 컨텐츠 스타일 */
.MainDisplayTabs_executionPlanContent__sBTJ3 {
  padding: 0;
  background-color: #f9f9f9;
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;
}

.MainDisplayTabs_planTextOutput__UVtIz {
  white-space: pre;
  word-break: normal;
  font-family: var(--font-mono, 'Consolas', monospace);
  font-size: var(--font-size-mono, 13px);
  margin: 0;
  padding: 8px 4px;
}
.MainDisplayTabs_planScrollArea__J1ism {
  padding-top: 4px;
}

/* 실행계획 인터랙티브 행 */
.MainDisplayTabs_planRow__SoxSy {
  cursor: pointer;
  transition: background 0.1s;
  border-radius: 2px;
}
.MainDisplayTabs_planRow__SoxSy:hover {
  background: #e3f2fd;
}
.MainDisplayTabs_planRowActive__W0Dn3 {
  background: #bbdefb !important;
  outline: 1px solid #64b5f6;
  outline-offset: -1px;
}
.MainDisplayTabs_planRowPredicate__GYuaK {
  /* 왼쪽 선은 **배치에 영향을 주지 않게** 안쪽 그림자로 — border + 음수 margin 은 정확히 상쇄되지 않아
     조건(*) 줄만 글자·구분선이 살짝 밀렸다(화면 확인 2026-10-05) */
  box-shadow: inset 2px 0 0 #ff9800;
}
.MainDisplayTabs_planSearchMatch__kch6b {
  background: rgba(255, 235, 59, 0.25) !important;
}

.MainDisplayTabs_planRowPredicateHighlight__4ctzN {
  background: #fff3e0 !important;
  box-shadow: inset 3px 0 0 #ff9800;   /* border 를 쓰면 그 폭만큼 줄이 오른쪽으로 밀린다 */
  font-weight: 500;
}

/* 실행계획 좌우 분할 컨테이너 */
.MainDisplayTabs_planSplitContainer__7lfUO {
  display: flex !important;
  flex-direction: row !important;
  gap: 0;
  /* 남은 높이만 — height:100% 면 탭 머리줄만큼 넘쳐 계획 맨 아랫줄이 상태 줄 밑으로 잘렸다(신고 2026-10-02) */
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}
.MainDisplayTabs_planLeftPane__Fms8C {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  border-right: 1px solid #e0e0e0;
  position: relative;
}
/* 계획 본문 + 미니맵 — 미니맵은 **이 안에서만** 서서 위 도구 줄(복사·내보내기·보관)을 덮지 않는다.
   예전에는 왼쪽 칸 전체 높이에 떠 있어 맨 오른쪽 「보관」 버튼을 가렸다(신고 2026-10-02) */
.MainDisplayTabs_planScrollWrap__4Aw60 {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.MainDisplayTabs_planScrollArea__J1ism {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding-right: 46px; /* 미니맵 공간 확보 */
  padding-bottom: 8px; /* 맨 아랫줄이 가장자리에 붙지 않게 */
}
/* 미니맵이 세로 위치를 보여 주고 끌어 옮길 수도 있으니 세로 스크롤바는 감춘다(요청). 가로 스크롤바는 남긴다 */
.MainDisplayTabs_planScrollArea__J1ism::-webkit-scrollbar:vertical { width: 0; }
/* 다크 모드는 모든 요소에 scrollbar-color 를 건다(App.css) — 그러면 Chrome 이 위 웹킷 규칙을 무시해 세로 스크롤바가
   그대로 보였다(2026-10-05). 여기서만 기본값으로 되돌리고 가로 스크롤바 색은 웹킷 규칙으로 준다 */
html .MainDisplayTabs_planScrollArea__J1ism { scrollbar-color: auto; }
[data-theme="dark"] .MainDisplayTabs_planScrollArea__J1ism::-webkit-scrollbar { background: #1e1e1e; height: 12px; }
[data-theme="dark"] .MainDisplayTabs_planScrollArea__J1ism::-webkit-scrollbar-track { background: #1e1e1e; }
[data-theme="dark"] .MainDisplayTabs_planScrollArea__J1ism::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }

/* 실행계획 행번호 */
.MainDisplayTabs_planLineNum__5pjjA {
  display: inline-block;
  width: 30px;
  text-align: right;
  padding-right: 8px;
  color: #aaa;
  font-size: 0.85em;
  font-family: inherit;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.MainDisplayTabs_planLineNum__5pjjA:hover {
  color: #2196f3;
}
.MainDisplayTabs_planLineBookmarked__R2MCX {
  color: #2196f3 !important;
}
.MainDisplayTabs_planLineBookmarked__R2MCX::before {
  content: '\\25CF ';
  font-size: 8px;
}
.MainDisplayTabs_planLineBookmarkedBg__dTsu1 {
  background: rgba(33, 150, 243, 0.06);
}

/* 실행계획 미니맵 — **평소에는 숨고 이 영역에 마우스가 올 때만** 보인다
   (사용자 요청 2026-09-20, 편집기 미니맵 \`.sql-editor-minimap.is-idle\` 과 같은 규칙).
   편집기는 포커스로 판정하지만 여기는 읽기 전용 \`<pre>\` 라 포커스가 가지 않아 hover 로 본다.
   자리(\`.planScrollArea\` 의 padding-right)는 늘 비워 둔다 — 나타날 때 본문이 밀리면
   미니맵을 숨겨 얻은 것보다 눈에 거슬린다. */
.MainDisplayTabs_planMinimap__346Jk {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  background: rgba(245, 246, 248, 0.85);
  border-left: 1px solid #e0e0e0;
  cursor: pointer;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  transition: opacity 160ms ease;
}
.MainDisplayTabs_planLeftPane__Fms8C:hover .MainDisplayTabs_planMinimap__346Jk {
  opacity: 1;
  pointer-events: auto;
}
.MainDisplayTabs_planMinimap__346Jk:hover {
  background: rgba(238, 240, 244, 0.95);
}

@media (prefers-reduced-motion: reduce) {
  .MainDisplayTabs_planMinimap__346Jk { transition: none; }
}
.MainDisplayTabs_planRightPane__gB9P3 {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  padding: 0;
  background: #fafbfc;
  font-family: var(--font-ui, 'Segoe UI', sans-serif);
  font-size: var(--font-size-ui-small, 11px);
  overflow: hidden;
}
.MainDisplayTabs_planRightPaneWide__COAsC {
  flex: 0 0 510px !important;
}
.MainDisplayTabs_planRightHeader__W04tV {
  flex-shrink: 0;
  padding: 6px 8px 0 8px;
  border-bottom: 1px solid var(--color-border, #e0e0e0);
}
.MainDisplayTabs_planRightBody__Edr-m {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}
.MainDisplayTabs_planRightTitle__Ho3Yp {
  font-weight: 700;
  font-size: 12px;
  color: #555;
  padding: 4px 0 8px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 8px;
}
.MainDisplayTabs_planRightEmpty__zgUdX {
  color: #999;
  font-style: italic;
  text-align: center;
  padding: 20px 0;
}

/* Predicate 요약 (좌측 하단) */
.MainDisplayTabs_predSummary__B4sb- {
  flex-shrink: 0;
  border-top: 1px solid #e0e0e0;
  padding: 8px 10px;
  background: #f5f5f5;
  max-height: 120px;
  overflow-y: auto;
}
.MainDisplayTabs_predSummaryTitle__LrTiy {
  font-weight: 600;
  font-size: 11px;
  color: #555;
  margin-bottom: 4px;
}
.MainDisplayTabs_predItem__wWy9Z {
  font-size: 11px;
  padding: 3px 6px;
  margin-bottom: 2px;
  border-radius: 3px;
  font-family: monospace;
  word-break: break-all;
}
.MainDisplayTabs_predItem__wWy9Z code {
  font-size: 11px;
}
.MainDisplayTabs_pred_access__cbnNH {
  background: #e8f5e9;
  border-left: 3px solid #4caf50;
}
.MainDisplayTabs_pred_filter__natSE {
  background: #fff8e1;
  border-left: 3px solid #ff9800;
}
.MainDisplayTabs_predType__XwKEX {
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  margin-right: 6px;
  color: #666;
}

/* 오브젝트 카드 */
/* 조회 결과에서 뽑은 필터 리본. 켜짐/꺼짐이 색으로 드러나야 토글이라는 것이 읽힌다. */
.MainDisplayTabs_objRibbon__ILa05 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    padding: 6px 8px;
    border-bottom: 1px solid var(--color-border, #e5e7eb);
}

.MainDisplayTabs_objRibbonSep__WXgl6 {
    width: 1px;
    align-self: stretch;
    margin: 2px 4px;
    background: var(--color-border, #e5e7eb);
}

.MainDisplayTabs_objChip__5rIwf {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 10px;
    background: none;
    color: var(--color-text-secondary, #6b7280);
    font-size: 11px;
    cursor: pointer;
    white-space: nowrap;
    transition: color 150ms ease, border-color 150ms ease, background-color 150ms ease;
}
.MainDisplayTabs_objChip__5rIwf:hover { border-color: var(--color-accent, #3b82f6); color: var(--color-accent, #3b82f6); }

/* 켜진 칩 — 앱의 다른 활성 표시와 같은 강조색 */
.MainDisplayTabs_objChipOn__0OXw0 {
    border-color: var(--color-accent, #3b82f6);
    color: var(--color-accent, #3b82f6);
    background: var(--color-hover, #eceef1);
    font-weight: 600;
}

.MainDisplayTabs_objChipCount__LakVB { opacity: 0.7; font-size: 10px; }

[data-theme="dark"] .MainDisplayTabs_objRibbon__ILa05 { border-color: var(--color-border); }
[data-theme="dark"] .MainDisplayTabs_objRibbonSep__WXgl6 { background: var(--color-border); }
[data-theme="dark"] .MainDisplayTabs_objChip__5rIwf { border-color: var(--color-border); color: var(--color-text-secondary); }
[data-theme="dark"] .MainDisplayTabs_objChipOn__0OXw0 { background: var(--color-hover); }

@media (prefers-reduced-motion: reduce) {
    .MainDisplayTabs_objChip__5rIwf { transition: none; }
}

/* 전체 DDL 버튼 — 카드 머리의 보조 동작이라 테두리만 */
.MainDisplayTabs_ddlBtn__3\\+9Vs {
    margin-left: auto;
    padding: 1px 7px;
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 3px;
    background: none;
    color: var(--color-text-secondary, #6b7280);
    font-size: 10px;
    cursor: pointer;
    white-space: nowrap;
    transition: color 150ms ease, border-color 150ms ease;
}
.MainDisplayTabs_ddlBtn__3\\+9Vs:hover { color: var(--color-accent, #3b82f6); border-color: var(--color-accent, #3b82f6); }

/* 조립본이라는 사실을 알리는 줄 */
.MainDisplayTabs_ddlNote__H-B1g {
    margin: 4px 8px;
    padding: 4px 8px;
    border-radius: 3px;
    background: var(--color-warning-bg, #fef3c7);
    color: var(--color-warning-text, #92400e);
    font-size: 11px;
}

[data-theme="dark"] .MainDisplayTabs_ddlBtn__3\\+9Vs { border-color: var(--color-border); color: var(--color-text-secondary); }
[data-theme="dark"] .MainDisplayTabs_ddlNote__H-B1g { background: #78350f; color: #fde68a; }

@media (prefers-reduced-motion: reduce) {
    .MainDisplayTabs_ddlBtn__3\\+9Vs { transition: none; }
}

/* 파티션 배지 — 테이블·인덱스 모두 같은 모양. 예전에는 인덱스 쪽만 인라인 스타일이라
   다크에서 밝은 상자로 남았고 「GLOBAL」 만 적혀 무엇의 구분인지 알 수 없었다. */
.MainDisplayTabs_partBadge__KMKMc {
    margin-left: 4px;
    padding: 1px 6px;
    border-radius: 3px;
    background: var(--color-bg-tertiary, #e8ecf0);
    color: var(--color-text-secondary, #4b5563);
    font-size: 10px;
    font-weight: 500;
    white-space: nowrap;
}

[data-theme="dark"] .MainDisplayTabs_partBadge__KMKMc {
    background: var(--color-bg-tertiary);
    color: var(--color-text-secondary);
}

/* 인덱스 생성일시 — 컬럼 목록과 함께 기본으로 보이는 두 가지 중 하나 */
.MainDisplayTabs_idxCreated__MJYpR {
    font-size: 10px;
    color: var(--color-text-muted, #9ca3af);
    margin-top: 2px;
}

/* 상세보기 — 필터가 아니라 **표시 옵션**이라 리본 칩과 모양을 달리한다 */
.MainDisplayTabs_objDetailToggle__7lXVo {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    font-size: 11px;
    color: var(--color-text-secondary, #6b7280);
    cursor: pointer;
    white-space: nowrap;
}

[data-theme="dark"] .MainDisplayTabs_idxCreated__MJYpR { color: var(--color-text-muted); }
[data-theme="dark"] .MainDisplayTabs_objDetailToggle__7lXVo { color: var(--color-text-secondary); }

.MainDisplayTabs_objCard__DPsap {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #fff;
  transition: box-shadow 0.2s;
}
.MainDisplayTabs_objCardHighlight__nPRfd {
  box-shadow: 0 0 0 2px #42a5f5;
  border-color: #42a5f5;
}
.MainDisplayTabs_objCardHeader__crLoo {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background: #f0f4f8;
  border-radius: 6px 6px 0 0;
  font-weight: 600;
  font-size: 11px;
}
.MainDisplayTabs_objCardIcon__\\+fYZp {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background: #1976d2;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}
.MainDisplayTabs_objCardName__wkL7E {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 스키마명은 **작게** — 같은 카드에서 눈이 찾는 것은 테이블명이다 (2026-09-18) */
.MainDisplayTabs_objCardSchema__dKw9b {
  font-size: 10px;
  color: var(--color-text-muted, #9ca3af);
  flex-shrink: 0;
}

/* 주석은 이름 오른편에 한 줄로. 자리를 다투면 **주석이 먼저 줄어든다**(이름이 우선이다). */
.MainDisplayTabs_objCardComment__5hShp {
  font-size: 10px;
  color: #888;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.MainDisplayTabs_objStatGrid__XVg-t {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  padding: 4px 8px 6px;
}
.MainDisplayTabs_objStatItem__bCL9r {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
}
.MainDisplayTabs_objStatLabel__ZmLb7 { color: #888; }
.MainDisplayTabs_objStatValue__iBZYu { font-weight: 600; color: #333; }

/* 인덱스 카드 */
.MainDisplayTabs_idxCard__bqv4I {
  margin: 4px 6px 4px 12px;
  padding: 4px 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fdfdfd;
  transition: box-shadow 0.2s;
}
.MainDisplayTabs_idxHeader__FL7PF {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
}
.MainDisplayTabs_idxIcon__d\\+Dlr {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background: #43a047;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  flex-shrink: 0;
}
.MainDisplayTabs_idxName__GQhvB {
  font-weight: 600;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.MainDisplayTabs_idxStatus__yJxcv {
  font-size: 9px;
  color: #888;
  margin-left: auto;
}
.MainDisplayTabs_idxCols__3Gsnj {
  font-size: 10px;
  color: #1565c0;
  padding: 2px 0 2px 20px;
  font-family: monospace;
}

/* 쿼리 결과 탭 전체 컨테이너 (기존 subTabsContainer에서 이름 변경 또는 신규) */
.MainDisplayTabs_queryResultTabContainer__35COb {
    display: flex;
    flex-direction: column;
    /* .subTabsContainer 와 같은 이유 — height:100% 는 탭 머리줄만큼 넘쳐 가로 스크롤바가 잘린다 */
    flex: 1 1;
    min-height: 0;
    min-width: 0;
}

/* "더보기" 버튼 및 메시지 관련 스타일 */
.MainDisplayTabs_fetchMoreContainer__K2rGq {
    padding: 10px;
    text-align: center;
    border-top: 1px solid #eee; /* 결과 그리드와 구분선 */
}

.MainDisplayTabs_fetchMoreButton__sYMW- {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.MainDisplayTabs_fetchMoreButton__sYMW-:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.MainDisplayTabs_fetchMoreButton__sYMW-:hover:not(:disabled) {
    background-color: #0056b3;
}

.MainDisplayTabs_loadingMessage__NA3ta, 
.MainDisplayTabs_queryErrorBanner__c1Aln { /* .noMoreDataMessage 제거 또는 다른 스타일 적용 */
    padding: 10px;
    text-align: center;
    font-style: italic;
    color: #555;
    background-color: #f9f9f9;
    border-top: 1px solid #eee;
}

.MainDisplayTabs_loadingMoreIndicator__yS6\\+W {
    padding: 10px;
    text-align: center;
    font-style: italic;
    color: #007bff; /* 로딩 색상 */
    background-color: #f9f9f9;
    /* border-top: 1px solid #eee; - 필요시 유지 */
    height: 30px; /* 로딩바 공간 확보 (애니메이션 추가 가능) */
}

/* fetchMoreContainer 및 fetchMoreButton, noMoreDataMessage 스타일은 이제 불필요하므로 제거 */
.MainDisplayTabs_fetchMoreContainer__K2rGq,
.MainDisplayTabs_fetchMoreButton__sYMW-,
.MainDisplayTabs_noMoreDataMessage__0XKzS {
    display: none; /* 완전히 제거 */
}

.MainDisplayTabs_queryErrorBanner__c1Aln {
    background-color: #ffebee; /* 옅은 빨간색 배경 */
    color: #c62828; /* 어두운 빨간색 텍스트 */
    font-style: normal;
    border-bottom: 1px solid #ffcdd2; /* 빨간색 계열 테두리 */
    border-top: none; /* 위쪽 테두리는 보통 subTabsHeader가 처리 */
    margin-bottom: 5px; /* ResultGrid와의 간격 */
}

/* 오류는 왼쪽 정렬로, 코드마다 한 줄(utils/errorLines). 길면 배너 안에서 스크롤 — 결과 칸을 밀어내지 않는다 */
.MainDisplayTabs_queryErrorBanner__c1Aln { display: flex; align-items: flex-start; gap: 8px; text-align: left; padding: 8px 12px; max-height: 40%; overflow-y: auto; flex-shrink: 0; }
.MainDisplayTabs_queryErrorBanner__c1Aln strong { flex: 0 0 auto; }
.MainDisplayTabs_queryErrorLines__lY9zj { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 2px; overflow-wrap: anywhere; line-height: 1.5; -webkit-user-select: text; user-select: text; }
.MainDisplayTabs_queryErrorMain__My4ba { font-weight: 600; }
.MainDisplayTabs_queryErrorTrace__bAKJ0 { font-family: Consolas, 'Nanum Gothic Coding', monospace; font-size: 0.92em; opacity: 0.8; }

.MainDisplayTabs_queryErrorBanner__c1Aln strong {
    font-weight: bold;
}

/* 다크모드 — 에러 배너: 채도 낮춘 빨강 배경 + 밝은 빨강 텍스트 */
[data-theme="dark"] .MainDisplayTabs_queryErrorBanner__c1Aln {
    background-color: rgba(220, 53, 69, 0.18);
    color: #ff8a80;
    border-bottom-color: rgba(220, 53, 69, 0.4);
}
[data-theme="dark"] .MainDisplayTabs_queryErrorBanner__c1Aln strong {
    color: #ffb4b4;
}
[data-theme="dark"] .MainDisplayTabs_queryErrorBanner__c1Aln a {
    color: #ffb4b4;
}

/* ======== 다크모드 ======== */
[data-theme="dark"] .MainDisplayTabs_subTabsContainer__SPQfO {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_subTabsHeader__zYO8K {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_subTabButton__W5txA {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V .MainDisplayTabs_subTabButton__W5txA {
  color: var(--color-text);
  background: var(--color-bg);
}
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB {
  background: var(--color-bg-tertiary);
  color: var(--color-text-muted);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V {
  background: var(--color-bg);
  color: var(--color-text);
  border-color: var(--color-border);
  border-bottom-color: var(--color-bg);
}
[data-theme="dark"] .MainDisplayTabs_executionPlanContent__sBTJ3 {
  background: var(--color-bg);
}
[data-theme="dark"] .MainDisplayTabs_planTextOutput__UVtIz {
  color: var(--color-text);
}
[data-theme="dark"] .MainDisplayTabs_planLeftPane__Fms8C {
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_planRightPane__gB9P3 {
  background: var(--color-bg-secondary);
  color: var(--color-text);
}
[data-theme="dark"] .MainDisplayTabs_planRightTitle__Ho3Yp {
  color: var(--color-text-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_objCard__DPsap {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_objCardHeader__crLoo {
  background: var(--color-bg-secondary);
}
[data-theme="dark"] .MainDisplayTabs_idxCard__bqv4I {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_predSummary__B4sb- {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_planRow__SoxSy:hover {
  background: var(--color-hover);
}
[data-theme="dark"] .MainDisplayTabs_planRowActive__W0Dn3 {
  background: #264f78 !important;
  outline-color: var(--color-accent-fg);
}
[data-theme="dark"] .MainDisplayTabs_planMinimap__346Jk {
  background: rgba(37,37,38,0.85);
  border-color: var(--color-border);
}

[data-theme="dark"] .MainDisplayTabs_planRowPredicateHighlight__4ctzN {
  background: rgba(255, 152, 0, 0.2) !important;
  box-shadow: inset 3px 0 0 #ffb74d;
}

[data-theme="dark"] .MainDisplayTabs_planSearchMatch__kch6b {
  background: rgba(255, 235, 59, 0.15) !important;
}

[data-theme="dark"] .MainDisplayTabs_pred_access__cbnNH {
  background: rgba(76, 175, 80, 0.2);
  border-left-color: #81c784;
}

[data-theme="dark"] .MainDisplayTabs_pred_filter__natSE {
  background: rgba(255, 152, 0, 0.2);
  border-left-color: #ffb74d;
}
[data-theme="dark"] .MainDisplayTabs_planLineNum__5pjjA {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MainDisplayTabs_noTabsMessage__YSKFA {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MainDisplayTabs_subTabsContent__pyW55 {
  background: var(--color-bg);
}
[data-theme="dark"] .MainDisplayTabs_infoTable__zX80K {
  background: var(--color-bg);
}
[data-theme="dark"] .MainDisplayTabs_infoTable__zX80K th {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_infoTable__zX80K td {
  border-color: var(--color-border);
  color: var(--color-text);
  background: var(--color-bg);
}
[data-theme="dark"] .MainDisplayTabs_infoTable__zX80K tbody tr:nth-child(even) td {
  background: var(--color-bg-secondary);
}
[data-theme="dark"] .MainDisplayTabs_infoTable__zX80K tbody tr:hover td {
  background: var(--color-hover);
}
[data-theme="dark"] .MainDisplayTabs_closeTabButton__xK0\\+i {
  color: var(--color-text-muted);
} [data-theme="dark"] .MainDisplayTabs_mainTabButton__uU\\+z7 { color: var(--color-text-muted) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .MainDisplayTabs_mainTabButton__uU\\+z7.MainDisplayTabs_active__JsB9V,
[data-theme="dark"] .MainDisplayTabs_activeMainTab__JiqgL { background: var(--color-bg) !important; color: var(--color-text) !important; border-bottom-color: var(--color-accent-fg) !important; }

[data-theme="dark"] .MainDisplayTabs_mainTabsContentArea__oixj8,
[data-theme="dark"] .MainDisplayTabs_queryResultTabContainer__35COb,
[data-theme="dark"] .MainDisplayTabs_subTabsContainer__SPQfO {
  background: var(--color-bg) !important;
}

[data-theme="dark"] .MainDisplayTabs_mainTabsSidebar__ZSMLg,
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB {
  background: var(--color-bg-secondary) !important;
  border-right-color: var(--color-border) !important;
}
[data-theme="dark"] .MainDisplayTabs_tabActionsArea__AT5mr {
  background: var(--color-bg-secondary) !important;
  border-left-color: var(--color-border) !important;
}
[data-theme="dark"] .MainDisplayTabs_mainTabButton__uU\\+z7:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .MainDisplayTabs_closeTabButton__xK0\\+i:hover { color: #ff6b6b !important; }
[data-theme="dark"] .MainDisplayTabs_planSearchMatch__kch6b { background: rgba(255,235,59,0.1) !important; }
[data-theme="dark"] .MainDisplayTabs_mainTabsSidebar__ZSMLg { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .MainDisplayTabs_queryResultTabContainer__35COb { background: var(--color-bg) !important; }
/* 탭이 없을 때의 안내 — 머리말 위에 밝은 상자·밝은 테두리(#ddd)로 떠 보이지 않게 */
[data-theme="dark"] .MainDisplayTabs_subTabButtonPlaceholder__W1m\\+Q { background: transparent !important; color: var(--color-text-muted); }
[data-theme="dark"] .MainDisplayTabs_tabActionsArea__AT5mr { background: var(--color-bg-secondary) !important; }
[data-theme="dark"] .MainDisplayTabs_tabButtonsArea__tbty6 { background: var(--color-bg-secondary) !important; }

/* Table Info CSS / Predicate Item Dark Mode */
[data-theme="dark"] .MainDisplayTabs_objStatItem__bCL9r { color: var(--color-text); }
[data-theme="dark"] .MainDisplayTabs_objStatLabel__ZmLb7 { color: var(--color-text-muted); }
[data-theme="dark"] .MainDisplayTabs_objStatValue__iBZYu { color: var(--color-text); }
[data-theme="dark"] .MainDisplayTabs_objCardComment__5hShp { color: var(--color-text-muted); }
[data-theme="dark"] .MainDisplayTabs_idxName__GQhvB { color: var(--color-text); }
[data-theme="dark"] .MainDisplayTabs_idxCols__3Gsnj { color: #6cb6ff; }
[data-theme="dark"] .MainDisplayTabs_idxStatus__yJxcv { color: var(--color-text-muted); }

[data-theme="dark"] .MainDisplayTabs_predSummaryTitle__LrTiy { color: var(--color-text-secondary); }
[data-theme="dark"] .MainDisplayTabs_predItem__wWy9Z { color: var(--color-text); }
[data-theme="dark"] .MainDisplayTabs_predItem__wWy9Z code { color: #89b4fa; }
[data-theme="dark"] .MainDisplayTabs_pred_access__cbnNH { background: rgba(76, 175, 80, 0.15); border-left-color: #4caf50; }
[data-theme="dark"] .MainDisplayTabs_pred_filter__natSE { background: rgba(255, 152, 0, 0.15); border-left-color: #ff9800; }
[data-theme="dark"] .MainDisplayTabs_predType__XwKEX { color: var(--color-text-muted); }

[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB { background: var(--color-bg-tertiary) !important; }
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V { background: var(--color-bg) !important; border-bottom-color: var(--color-bg) !important; }
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V .MainDisplayTabs_subTabButton__W5txA { color: var(--color-text) !important; }
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB:not(.MainDisplayTabs_active__JsB9V) .MainDisplayTabs_subTabButton__W5txA { color: var(--color-text-muted) !important; }
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB.MainDisplayTabs_active__JsB9V:hover { background: var(--color-bg) !important; }
[data-theme="dark"] .MainDisplayTabs_subTabButtonContainer__GAjBB:not(.MainDisplayTabs_active__JsB9V):hover { background: var(--color-hover) !important; }
[data-theme="dark"] .MainDisplayTabs_closeTabButton__xK0\\+i { background: transparent !important; color: var(--color-text-muted) !important; }
[data-theme="dark"] .MainDisplayTabs_closeTabButton__xK0\\+i:hover { color: #ff6b6b !important; background: rgba(255,107,107,0.15) !important; }
[data-theme="dark"] .MainDisplayTabs_kindPinButton__5qxvO:hover { background: var(--color-hover); }
[data-theme="dark"] .MainDisplayTabs_stopTabButton__m\\+o73 { color: var(--color-text) !important; }
[data-theme="dark"] .MainDisplayTabs_planRightHeader__W04tV { border-color: var(--color-border) !important; }
[data-theme="dark"] .MainDisplayTabs_planRightBody__Edr-m { background: var(--color-bg-secondary) !important; }

/* 실행 중 탭의 로딩 스피너 */
.MainDisplayTabs_subTabSpinner__y-fpv {
  animation: MainDisplayTabs_subTabSpinnerRotate__v7djF 1s linear infinite;
  color: var(--color-text-muted, #6b7280);
}
@keyframes MainDisplayTabs_subTabSpinnerRotate__v7djF {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* 실행 중 — 결과 영역 본문.
   빈 결과(0건)와 **아직 안 끝난 것**을 눈으로 구분할 수 있어야 한다. */
.MainDisplayTabs_runningMessage__ox\\+aB {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--color-text-muted, #6b7280);
  font-style: italic;
  animation: MainDisplayTabs_runningFadeIn__uaPRx 160ms ease-out;
}
.MainDisplayTabs_runningSpinner__98dyj {
  width: 14px;
  height: 14px;
  border: 2px solid var(--color-border, #d1d5db);
  border-top-color: var(--color-primary, #3b82f6);
  border-radius: 50%;
  animation: MainDisplayTabs_subTabSpinnerRotate__v7djF 1s linear infinite;
}
@keyframes MainDisplayTabs_runningFadeIn__uaPRx {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .MainDisplayTabs_runningMessage__ox\\+aB { animation: none; }
  .MainDisplayTabs_runningSpinner__98dyj { animation: none; }
}

/* 계획 탭의 도구줄 — 검색 + 복사·내보내기·보관.
   이 계획 하나에만 작용하는 것들이라 메뉴가 아니라 대상 가까이 둔다
   (docs/ui-command-placement.md 규칙 4). */
.MainDisplayTabs_planToolRow__ifcE5 {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}
.MainDisplayTabs_planToolBtns__r1ooV {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding-right: 6px;
}
.MainDisplayTabs_planToolBtn__BKXoe {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid var(--color-border, #d0d5dd);
  border-radius: 3px;
  background: var(--color-bg, #fff);
  color: var(--color-text, #1f2937);
  font-size: 11px;
  font-family: var(--font-ui, 'Segoe UI', sans-serif);
  cursor: pointer;
  white-space: nowrap;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}
.MainDisplayTabs_planToolBtn__BKXoe:hover {
  border-color: var(--color-accent, #3b82f6);
  color: var(--color-accent, #3b82f6);
}

[data-theme="dark"] .MainDisplayTabs_planToolBtn__BKXoe {
  background: transparent;
  color: var(--color-text);
  border-color: var(--color-border);
}
[data-theme="dark"] .MainDisplayTabs_planToolBtn__BKXoe:hover {
  background: var(--color-hover);
  border-color: var(--color-accent-fg);
  color: var(--color-accent-fg);
}

@media (prefers-reduced-motion: reduce) {
  .MainDisplayTabs_planToolBtn__BKXoe { transition: none; }
}

/* 실행계획 본문의 넓은 글자(한글 등) - 정확히 고정폭 2칸. 고정폭 글꼴에 한글이 없으면 대체 글꼴의 한글이 2칸보다 넓어
   한글이 든 줄만 뒤가 밀렸다(utils/monoWide.js, 2026-10-05) */
.MainDisplayTabs_wideCh__EbqRR {
  display: inline-block;
  width: 2ch;
  text-align: center;
  overflow: hidden;
  vertical-align: bottom;
}

/* SQL Monitor 리포트 — 실행계획 아래에 접어서(2026-10-07). 펼치면 이 칸만 스크롤한다 */
.MainDisplayTabs_monitorReport__rtqp\\+ {
  flex-shrink: 0;
  border-top: 1px solid var(--color-border, #e0e0e0);
  font-size: 11px;
}
.MainDisplayTabs_monitorReport__rtqp\\+ > summary {
  padding: 5px 10px;
  cursor: pointer;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
}
.MainDisplayTabs_monitorReport__rtqp\\+ > pre {
  margin: 0;
  max-height: 260px;
  overflow: auto;
  padding: 6px 10px 10px;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 11px;
  line-height: 1.45;
  white-space: pre;
  animation: MainDisplayTabs_monitorReportIn__\\+wuhi 160ms ease-out;
}
@keyframes MainDisplayTabs_monitorReportIn__\\+wuhi {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .MainDisplayTabs_monitorReport__rtqp\\+ > pre { animation: none; }
}

/* ── 결과 탭 머리줄은 배경 한 장(2026-10-07, 사용자 요청) ──
   다크에서 머리줄(#2d2d2d)과 탭·버튼 영역(#252526)의 색이 달라 머리줄 위 여백(5px)·오른쪽 여백이 굵은 선처럼 보였다.
   머리줄이 색을 정하고 안쪽 영역은 투명으로 둔다. 아래 경계선은 1px 한 줄 — 그리드 쪽 테두리는 없앴다(App.css). */
[data-theme="dark"] .MainDisplayTabs_subTabsHeader__zYO8K { background-color: var(--color-bg-secondary) !important; }
[data-theme="dark"] .MainDisplayTabs_tabActionsArea__AT5mr,
[data-theme="dark"] .MainDisplayTabs_tabButtonsArea__tbty6 { background: transparent !important; }

/* 오브젝트 상세 — 인덱스는 개수만 보이다가 누르면 펼친다 */
.MainDisplayTabs_idxToggle__kq7aP { display: inline-flex; align-items: center; gap: 4px; margin: 4px 0 2px 8px; padding: 1px 8px; border: 1px solid var(--color-border, #d1d5db); border-radius: 10px; background: transparent; color: inherit; font-size: 11px; cursor: pointer; transition: background-color 150ms ease, border-color 150ms ease; }
.MainDisplayTabs_idxToggle__kq7aP:hover { border-color: var(--color-accent, #3b82f6); background: rgba(59, 130, 246, 0.08); }
.MainDisplayTabs_idxToggleArrow__LPP\\+d { font-size: 9px; opacity: 0.7; }
@media (prefers-reduced-motion: reduce) { .MainDisplayTabs_idxToggle__kq7aP { transition: none; } }

/* 실행 중인 문장의 모니터링 — 중지 단추 옆 */
.MainDisplayTabs_monitorTabButton__Hj-ML { white-space: nowrap; flex-shrink: 0; background: transparent; border: 1px solid var(--color-accent, #3b82f6); color: var(--color-accent, #3b82f6); cursor: pointer; font-size: 11px; font-weight: 500; padding: 3px 9px; margin-left: 4px; border-radius: 3px; transition: background-color 150ms ease, color 150ms ease; }
.MainDisplayTabs_monitorTabButton__Hj-ML:hover { background: var(--color-accent, #3b82f6); color: #fff; }
@media (prefers-reduced-motion: reduce) { .MainDisplayTabs_monitorTabButton__Hj-ML { transition: none; } }

/* 테이블 정보(F4) — 하위 탭은 나란히, 표는 결과 그리드처럼 촘촘하게(2026-10-28 신고: 글자가 크고 인덱스 목록이 밀려 안 보였다) */
.MainDisplayTabs_infoSubTabs__L1Cr4 {
    justify-content: flex-start;
    gap: 2px;
}
.MainDisplayTabs_infoSubTabs__L1Cr4 .MainDisplayTabs_subTabButton__W5txA {
    border-bottom: 2px solid transparent;
    color: var(--color-text-secondary, #666);
    transition: color 150ms ease, border-color 150ms ease;
}
.MainDisplayTabs_infoSubTabs__L1Cr4 .MainDisplayTabs_subTabButton__W5txA.MainDisplayTabs_active__JsB9V {
    color: var(--color-accent, #2563eb);
    border-bottom-color: var(--color-accent, #2563eb);
    font-weight: 600;
}
.MainDisplayTabs_infoTableCompact__uLpVE {
    font-size: var(--font-size-ui-small, 11px);
}
.MainDisplayTabs_infoTableCompact__uLpVE th,
.MainDisplayTabs_infoTableCompact__uLpVE td {
    padding: 3px 8px;
    line-height: 1.4;
}
.MainDisplayTabs_infoTableCompact__uLpVE th {
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 1;
}
.MainDisplayTabs_subTabsContainer__SPQfO .MainDisplayTabs_tableDetailContent__e2M5F {
    padding: 6px 8px;
    animation: MainDisplayTabs_info-fade__JH22l 150ms ease-out;
}
.MainDisplayTabs_subTabsContainer__SPQfO .MainDisplayTabs_tableDetailContent__e2M5F h4 {
    font-size: 12px;
    margin-bottom: 6px;
}
@keyframes MainDisplayTabs_info-fade__JH22l { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
@media (prefers-reduced-motion: reduce) {
    .MainDisplayTabs_subTabsContainer__SPQfO .MainDisplayTabs_tableDetailContent__e2M5F { animation: none; }
    .MainDisplayTabs_infoSubTabs__L1Cr4 .MainDisplayTabs_subTabButton__W5txA { transition: none; }
}

/* 오브젝트 탭 이름 — 스키마는 작게, 전체 폭은 제한하고 넘치면 「…」(전체 이름은 툴팁) — 2026-10-29 요청 */
.MainDisplayTabs_tabNameObject__lIPiR {
    display: inline-flex;
    align-items: baseline;
    max-width: 180px;
    min-width: 0;
    overflow: hidden;
}
.MainDisplayTabs_tabNameSchema__NkHnT {
    flex-shrink: 1;
    min-width: 0;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.85em;
    opacity: 0.75;
}
.MainDisplayTabs_tabNameTable__cCdz5 {
    flex-shrink: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/components/MainDisplayTabs.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY,GAAG,yEAAyE;AAC5F;;AAEA,wCAAwC;AACxC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,cAAc;AAClB;AACA;IACI,mCAAmC;AACvC;;AAEA,8CAAuB,0BAA0B;IAC7C,YAAY;IACZ,gBAAgB,EAAE,0CAA0C;IAC5D,yEAAyE;IACzE,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,aAAa,EAAE,oCAAoC;IACnD,YAAY,GAAG,qGAAqG;AACxH;;AAEA,8CAA8C;AAC9C;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iEAAiE;AACrE;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB;4CACwC;IACxC,SAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;yCACyC;AACzC;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,kDAAkD;IAClD,8CAA8C;IAC9C,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ;yDACqD;IACrD,YAAY;IACZ,gBAAgB,EAAE,mBAAmB;IACrC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;gDACgD;AAChD;IACI,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,0CAA0C;IAC1C,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,wBAAwB;AAC5B;AACA;IACI,2CAA2C;IAC3C,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA,kCAAkC;AAClC;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oDAAoD;IACpD,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,mDAAmD;IACnD,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,WAAW;AACf;;;AAGA;;2CAE2C;AAC3C;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,uDAAuD;AAC3D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,kBAAkB;IAClB,6CAA6C,EAAE,sCAAsC;IACrF,mBAAmB,EAAE,gCAAgC;IACrD,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,2FAA2F;AAC3F;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yDAAyD;AAC7D;AACA;IACI,mCAAmC;IACnC,kCAAkC;AACtC;AACA;;IAEI,cAAc;AAClB;AACA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,wCAAiB,gBAAgB,EAAE;AACvC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA,2FAA2F;AAC3F;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,uDAAuD;IACvD,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA,mDAA2B,gCAAgC;IACvD,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA,yCAAkB,qCAAqC;IACnD,YAAY;IACZ,gBAAgB,EAAE,0CAA0C;IAC5D,aAAa;IACb,sBAAsB;IACtB,YAAY,MAAM,6EAA6E;IAC/F,+CAA+C;AACnD;;AAEA,0DAA0D;;AAE1D;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;;IAEI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,cAAc,EAAE,gBAAgB;IAChC,aAAa,EAAE,cAAc;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mDAAmD;IACnD,sCAAsC;AAC1C;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oDAAoD;EACpD,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE;gDAC8C;EAC9C,iCAAiC;AACnC;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC,IAAI,mCAAmC;EACxE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,MAAM;EACN,4EAA4E;EAC5E,SAAW;EACX,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;4DAC4D;AAC5D;EACE,kBAAkB;EAClB,SAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB,EAAE,cAAc;EACnC,mBAAmB,EAAE,uBAAuB;AAC9C;AACA,kEAAkE;AAClE,qEAA8C,QAAQ,EAAE;AACxD;+DAC+D;AAC/D,8CAAgC,qBAAqB,EAAE;AACvD,gFAAkE,mBAAmB,EAAE,YAAY,EAAE;AACrG,sFAAwE,mBAAmB,EAAE;AAC7F,sFAAwE,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;;AAEzI,aAAa;AACb;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;;AAEA;;;;4BAI4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAe,gBAAgB,EAAE;AACnC;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,mDAAmD;EACnD,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,qDAAqD;AACvD;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA,YAAY;AACZ,oDAAoD;AACpD;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;IAC3C,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,kFAAkF;AACtF;AACA,wCAAiB,0CAA0C,EAAE,mCAAmC,EAAE;;AAElG,+BAA+B;AAC/B;IACI,0CAA0C;IAC1C,mCAAmC;IACnC,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA,uCAAgB,YAAY,EAAE,eAAe,EAAE;;AAE/C,wDAA0C,iCAAiC,EAAE;AAC7E,2DAA6C,+BAA+B,EAAE;AAC9E,sDAAwC,iCAAiC,EAAE,kCAAkC,EAAE;AAC/G,wDAA0C,8BAA8B,EAAE;;AAE1E;IACI,kCAAW,gBAAgB,EAAE;AACjC;;AAEA,oCAAoC;AACpC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,qDAAqD;AACzD;AACA,wCAAgB,mCAAmC,EAAE,0CAA0C,EAAE;;AAEjG,qBAAqB;AACrB;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;IAC5C,yCAAyC;IACzC,eAAe;AACnB;;AAEA,sDAAuC,iCAAiC,EAAE,kCAAkC,EAAE;AAC9G,sDAAwC,mBAAmB,EAAE,cAAc,EAAE;;AAE7E;IACI,kCAAU,gBAAgB,EAAE;AAChC;;AAEA;oDACoD;AACpD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,6CAA6C;IAC7C,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA,4CAA4C;AAC5C;IACI,eAAe;IACf,uCAAuC;IACvC,eAAe;AACnB;;AAEA,8CAA8C;AAC9C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,2CAA2C;IAC3C,eAAe;IACf,mBAAmB;AACvB;;AAEA,yDAA2C,8BAA8B,EAAE;AAC3E,8DAAgD,kCAAkC,EAAE;;AAEpF;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,wDAAwD;AACxD;EACE,eAAe;EACf,uCAAuC;EACvC,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA,uCAAgB,WAAW,EAAE;AAC7B,uCAAgB,gBAAgB,EAAE,WAAW,EAAE;;AAE/C,WAAW;AACX;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,sBAAsB;IACtB,sEAAsE;IACtE,SAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,kBAAkB;IAClB,0BAA0B,EAAE,gBAAgB;AAChD;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;2CACoB,uCAAuC;IACvD,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,cAAc,EAAE,UAAU;IAC1B,yBAAyB;IACzB,yCAAyC;IACzC,YAAY,EAAE,4BAA4B;AAC9C;;AAEA,8EAA8E;AAC9E;;;IAGI,aAAa,EAAE,WAAW;AAC9B;;AAEA;IACI,yBAAyB,EAAE,cAAc;IACzC,cAAc,EAAE,gBAAgB;IAChC,kBAAkB;IAClB,gCAAgC,EAAE,eAAe;IACjD,gBAAgB,EAAE,iCAAiC;IACnD,kBAAkB,EAAE,oBAAoB;AAC5C;;AAEA,2EAA2E;AAC3E,2CAAoB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9J,kDAA2B,cAAc,EAAE;AAC3C,0CAAmB,cAAc,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;AAChK,yCAAkB,gBAAgB,EAAE;AACpC,0CAAmB,uDAAuD,EAAE,iBAAiB,EAAE,YAAY,EAAE;;AAE7G;IACI,iBAAiB;AACrB;;AAEA,0CAA0C;AAC1C;IACI,yCAAyC;IACzC,cAAc;IACd,2CAA2C;AAC/C;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;AACA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC,EAAE,6DAA8C,yCAAyC,EAAE,4CAA4C,EAAE;AACzI;4DAC8C,sCAAsC,EAAE,mCAAmC,EAAE,sDAAsD,EAAE;;AAEnL;;;EAGE,sCAAsC;AACxC;;AAEA;;EAEE,gDAAgD;EAChD,kDAAkD;AACpD;AACA;EACE,gDAAgD;EAChD,iDAAiD;AACnD;AACA,mEAAoD,yCAAyC,EAAE;AAC/F,oEAAqD,yBAAyB,EAAE;AAChF,8DAAgD,2CAA2C,EAAE;AAC7F,8DAAgD,gDAAgD,EAAE,4CAA4C,EAAE;AAChJ,sEAAwD,sCAAsC,EAAE;AAChG,sDAAsD;AACtD,uEAAwD,kCAAkC,EAAE,8BAA8B,EAAE;AAC5H,6DAA+C,gDAAgD,EAAE;AACjG,6DAA+C,gDAAgD,EAAE;;AAEjG,8CAA8C;AAC9C,0DAA4C,wBAAwB,EAAE;AACtE,2DAA6C,8BAA8B,EAAE;AAC7E,2DAA6C,wBAAwB,EAAE;AACvE,6DAA+C,8BAA8B,EAAE;AAC/E,sDAAwC,wBAAwB,EAAE;AAClE,sDAAwC,cAAc,EAAE;AACxD,wDAA0C,8BAA8B,EAAE;;AAE1E,+DAAiD,kCAAkC,EAAE;AACrF,uDAAyC,wBAAwB,EAAE;AACnE,4DAA8C,cAAc,EAAE;AAC9D,0DAA4C,mCAAmC,EAAE,0BAA0B,EAAE;AAC7G,0DAA4C,mCAAmC,EAAE,0BAA0B,EAAE;AAC7G,uDAAyC,8BAA8B,EAAE;;AAEzE,oEAAsD,+CAA+C,EAAE;AACvG,kGAA6D,sCAAsC,EAAE,+CAA+C,EAAE;AACtJ,uIAA2E,mCAAmC,EAAE;AAChH,6IAAiF,yCAAyC,EAAE;AAC5H,wGAAmE,sCAAsC,EAAE;AAC3G,8GAAyE,yCAAyC,EAAE;AACpH,8DAA+C,kCAAkC,EAAE,yCAAyC,EAAE;AAC9H,oEAAqD,yBAAyB,EAAE,6CAA6C,EAAE;AAC/H,kEAAoD,8BAA8B,EAAE;AACpF,6DAA8C,mCAAmC,EAAE;AACnF,8DAAgD,4CAA4C,EAAE;AAC9F,4DAA8C,gDAAgD,EAAE;;AAEhG,mBAAmB;AACnB;EACE,wEAAiD;EACjD,uCAAuC;AACzC;AACA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;+CAC+C;AAC/C;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uCAAuC;EACvC,kBAAkB;EAClB,8DAAuC;AACzC;AACA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,+CAA+C;EAC/C,kBAAkB;EAClB,wEAAiD;AACnD;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,0CAAkB,eAAe,EAAE;EACnC,yCAAkB,eAAe,EAAE;AACrC;;AAEA;;yCAEyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;EACf,mDAAmD;EACnD,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sCAAe,gBAAgB,EAAE;AACnC;;AAEA;mDACmD;AACnD;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,kDAAkD;EAClD,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iEAAyC;AAC3C;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,+CAAuB,eAAe,EAAE;AAC1C;;AAEA;;2EAE2E;AAC3E,4DAA8C,sDAAsD,EAAE;AACtG;6DAC+C,kCAAkC,EAAE;;AAEnF,oCAAoC;AACpC,oCAAa,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,8CAA8C,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,gEAAgE,EAAE;AAC7T,0CAAmB,0CAA0C,EAAE,oCAAoC,EAAE;AACrG,0CAAkB,cAAc,EAAE,YAAY,EAAE;AAChD,0CAA0C,oCAAa,gBAAgB,EAAE,EAAE;;AAE3E,6BAA6B;AAC7B,2CAAoB,mBAAmB,EAAE,cAAc,EAAE,uBAAuB,EAAE,8CAA8C,EAAE,mCAAmC,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,yDAAyD,EAAE;AAC9U,iDAA0B,wCAAwC,EAAE,WAAW,EAAE;AACjF,0CAA0C,2CAAoB,gBAAgB,EAAE,EAAE;;AAElF,qFAAqF;AACrF;IACI,2BAA2B;IAC3B,QAAQ;AACZ;AACA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,qDAAqD;AACzD;AACA;IACI,mCAAmC;IACnC,iDAAiD;IACjD,gBAAgB;AACpB;AACA;IACI,0CAA0C;AAC9C;AACA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,0DAAmC;AACvC;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA,8CAAuB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACtH;IACI,sFAAwC,eAAe,EAAE;IACzD,2EAA6B,gBAAgB,EAAE;AACnD;;AAEA,uEAAuE;AACvE;IACI,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".mainDisplayTabsContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100%;\r\n    overflow: hidden;\r\n    flex-grow: 1;\r\n    min-width: 0;  /* flex 자식의 default min-width:auto 해제 — 자식 ResultGrid 가 가로로 부모를 뚫지 않도록. */\r\n}\r\n\r\n/* 탭 종류 아이콘 — 통합 헤더에서 결과/실행계획/오브젝트 구분. */\r\n.subTabKindIcon {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0 4px 0 2px;\r\n    color: var(--color-text-muted, #6b7280);\r\n    flex-shrink: 0;\r\n}\r\n.subTabButtonContainer.active .subTabKindIcon {\r\n    color: var(--color-accent, #2563eb);\r\n}\r\n\r\n.mainTabsContentArea { /* .mainTabsContent에서 변경 */\r\n    flex-grow: 1;\r\n    overflow: hidden; /* Prevent this container from scrolling */\r\n    /* 위쪽 여백은 좁게(2026-10-07, 「위쪽 여백을 조금 줄여줘」) — 도구줄 바로 아래라 10px 이면 탭이 떠 보였다 */\r\n    padding: 4px 10px 10px;\r\n    background-color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 0; /* Allow shrinking in flex context */\r\n    min-width: 0;  /* row-direction parent(.mainDisplayTabsContainer) 안에서 가로로 줄어들 수 있게 — 자식 ResultGrid 의 가로 스크롤 동작 보장. */\r\n}\r\n\r\n/* 개별 탭 내용에 대한 스타일 (ResultGrid 등은 자체 스타일 가짐) */\r\n.tabContent {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* 예를 들어 ResultGrid는 내부적으로 스크롤을 처리하므로, 여기서는 flex 설정만으로 충분할 수 있음 */\r\n}\r\n\r\n/* 하위 탭 (쿼리 결과 탭 내부) */\r\n.subTabsContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* 남은 높이만 쓴다. height:100% 이면 위의 탭 머리줄 높이만큼 넘쳐서, 부모의 overflow:hidden 에\r\n       표 아래쪽(가로 스크롤바)이 잘렸다(신고 2026-10-01). */\r\n    flex: 1 1 0;\r\n    min-height: 0;\r\n    min-width: 0;\r\n}\r\n\r\n/* 결과 탭 헤더 — 에디터 탭(.tabsContainer) 과 동일한 톤 (var(--color-tab-bg)).\r\n   상단에 padding 두어 탭 컨테이너가 약간 떠있는 듯한 효과. */\r\n.subTabsHeader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-end;\r\n    flex-shrink: 0;\r\n    border-bottom: 1px solid var(--color-border, #ddd);\r\n    background-color: var(--color-tab-bg, #f0f0f0);\r\n    padding: 3px 5px 0 5px;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.tabButtonsArea {\r\n    display: flex;\r\n    flex-grow: 1;\r\n    /* 줄어드는 것은 이 칸(가로 스크롤)이지 탭 하나하나가 아니다 — 탭이 눌리면 안의 「중지」·「모니터링」 글자가 접혀\r\n       탭 머리가 두 배로 높아졌다(2026-10-29 신고: 실행 중에만 줄바꿈된 채 유지) */\r\n    min-width: 0;\r\n    overflow-x: auto; /* 탭이 많아지면 가로 스크롤 */\r\n    overflow-y: hidden;\r\n}\r\n\r\n.tabActionsArea {\r\n    display: flex;\r\n    gap: 8px;\r\n    padding: 2px 10px;\r\n    flex-shrink: 0;\r\n    /* 왼쪽 구분선 없이 머리줄과 같은 배경 한 장(2026-10-07) */\r\n    background-color: transparent;\r\n    align-items: center;\r\n}\r\n\r\n/* 결과탭 액션 버튼 (전체출력/CSV저장) — 중립적인 회색 톤. 청색 채움 대신 outline+\r\n   subtle bg 로 톤 다운. 헤더 다른 요소들과 시각적으로 충돌하지 않게. */\r\n.actionButton {\r\n    padding: 3px 10px;\r\n    border: 1px solid #c0c0c0;\r\n    background-color: #f5f5f5;\r\n    color: #333;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    white-space: nowrap;\r\n    transition: background-color 0.2s, border-color 0.2s, color 0.2s;\r\n}\r\n\r\n.actionButton:hover:not(:disabled) {\r\n    background-color: #e0e0e0;\r\n    border-color: #999;\r\n    color: #000;\r\n}\r\n\r\n.actionButton:disabled {\r\n    background-color: #f5f5f5;\r\n    border-color: #d4d4d4;\r\n    color: #aaa;\r\n    cursor: not-allowed;\r\n    opacity: 0.7;\r\n}\r\n\r\n/* 다크모드 — actionButton 도 동일한 중립 톤. */\r\n:global([data-theme=\"dark\"]) .actionButton {\r\n    background-color: var(--color-bg-tertiary);\r\n    border-color: var(--color-border);\r\n    color: var(--color-text);\r\n}\r\n:global([data-theme=\"dark\"]) .actionButton:hover:not(:disabled) {\r\n    background-color: var(--color-hover);\r\n    border-color: var(--color-text-muted);\r\n    color: var(--color-text);\r\n}\r\n:global([data-theme=\"dark\"]) .actionButton:disabled {\r\n    background-color: var(--color-bg-secondary);\r\n    border-color: var(--color-border);\r\n    color: var(--color-text-muted);\r\n}\r\n\r\n/* 다크모드 — stopButton (위험 액션, 중지) */\r\n:global([data-theme=\"dark\"]) .stopButton {\r\n    background-color: #c0303f;\r\n    border-color: #c0303f;\r\n    color: #fff;\r\n}\r\n:global([data-theme=\"dark\"]) .stopButton:hover {\r\n    background-color: #a52833;\r\n    border-color: #a52833;\r\n}\r\n\r\n.stopButton {\r\n    padding: 6px 12px;\r\n    border: 1px solid #dc3545;\r\n    background-color: #dc3545;\r\n    color: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    white-space: nowrap;\r\n    transition: background-color 0.2s, border-color 0.2s;\r\n    margin-right: 8px;\r\n}\r\n\r\n.stopButton:hover {\r\n    background-color: #c82333;\r\n    border-color: #c82333;\r\n}\r\n\r\n.subTabButton {\r\n    padding: 4px 4px 4px 3px;\r\n    border: none;\r\n    background-color: transparent;\r\n    cursor: pointer;\r\n    font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n    font-size: var(--font-size-tab, 12px);\r\n    outline: none;\r\n    white-space: nowrap;\r\n    flex-grow: 0;\r\n    min-width: 0;\r\n    text-align: left;\r\n    color: #999;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    height: 100%;\r\n    line-height: 1;\r\n}\r\n\r\n.subTabButton:last-child {\r\n    border-right: none;\r\n}\r\n\r\n.subTabButton.active {\r\n    background-color: transparent;\r\n    font-weight: 500;\r\n    color: #333;\r\n}\r\n\r\n\r\n/* 결과 탭 컨테이너 — 에디터 탭(.tabItem) 과 동일한 모양 (border + 상단 둥글기).\r\n   비활성 탭은 회색, 활성 탭은 본문 배경색으로 합쳐져 컨텐츠와 연결된 듯한 느낌.\r\n   padding 으로 높이를 에디터 탭과 비슷하게 (~32px) 유지. */\r\n.subTabButtonContainer {\r\n    display: flex;\r\n    flex-shrink: 0;\r\n    white-space: nowrap;\r\n    align-items: center;\r\n    padding: 4px 4px;\r\n    background-color: #e9e9e9;\r\n    color: #666;\r\n    border: 1px solid #ccc;\r\n    border-bottom: none;\r\n    border-top-left-radius: 5px;\r\n    border-top-right-radius: 5px;\r\n    margin-right: 1px;\r\n    transition: background-color 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.subTabButtonContainer:not(.active):hover {\r\n    background-color: #d4d4d4;\r\n}\r\n\r\n.subTabButtonContainer.active {\r\n    background-color: var(--color-bg, #ffffff);\r\n    color: #333;\r\n    border-color: #ccc;\r\n    border-bottom-color: var(--color-bg, #ffffff); /* 헤더 border-bottom 과 겹쳐 컨텐츠와 연결된 효과 */\r\n    margin-bottom: -1px; /* 헤더 border-bottom 위로 살짝 끌어올림 */\r\n    z-index: 1;\r\n}\r\n\r\n.subTabButtonContainer.active .subTabButton {\r\n    color: #333 !important;\r\n    font-weight: 500 !important;\r\n}\r\n\r\n.subTabButtonContainer.active:hover {\r\n    background-color: var(--color-bg, #fff);\r\n}\r\n\r\n/* 결과 탭의 종류 아이콘 = 고정 단추(2026-10-21 — 따로 있던 책갈피 단추를 없앴다). 모양은 .subTabKindIcon 그대로, 고정되면 주황 */\r\n.kindPinButton {\r\n    background: transparent;\r\n    border: none;\r\n    padding: 2px;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n    transition: color 0.16s ease, background-color 0.16s ease;\r\n}\r\n.kindPinButton:hover {\r\n    color: var(--color-accent, #2563eb);\r\n    background: rgba(37, 99, 235, 0.1);\r\n}\r\n.kindPinButton.pinned,\r\n.subTabButtonContainer.active .kindPinButton.pinned {\r\n    color: #ff6b00;\r\n}\r\n.kindPinButton:focus-visible {\r\n    outline: 2px solid var(--color-accent, #2563eb);\r\n    outline-offset: 1px;\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n    .kindPinButton { transition: none; }\r\n}\r\n\r\n.stopTabButton {\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n    background-color: #dc3545;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    padding: 4px 10px;\r\n    margin-left: 6px;\r\n    border-radius: 3px;\r\n    transition: all 0.2s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    white-space: nowrap;\r\n}\r\n\r\n.stopTabButton:hover {\r\n    background-color: #c82333;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* 닫기 — 편집기 탭의 닫기(FileTabs .closeButton)와 같은 모양: 18px 동그라미, 호버하면 둥근 배경(사용자 요청 2026-10-26) */\r\n.closeTabButton {\r\n    background: transparent;\r\n    border: none;\r\n    color: #777;\r\n    cursor: pointer;\r\n    width: 18px;\r\n    height: 18px;\r\n    padding: 0;\r\n    margin-left: 4px;\r\n    margin-right: 2px;\r\n    line-height: 0;\r\n    border-radius: 50%;\r\n    flex-shrink: 0;\r\n    transition: color 0.2s ease, background-color 0.2s ease;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.closeTabButton:hover {\r\n    color: #d32f2f;\r\n    background: rgba(211, 47, 47, 0.12);\r\n}\r\n\r\n.subTabButtonPlaceholder { /* 빈 공간 스타일 이름 변경 또는 기존 스타일 유지 */\r\n    padding: 8px 12px;\r\n    border: none;\r\n    background-color: transparent;\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n    flex-grow: 1;\r\n}\r\n\r\n.subTabsContent { /* 이 부분이 ResultGrid 등을 직접 포함하는 컨테이너 */\r\n    flex-grow: 1;\r\n    overflow: hidden; /* Prevent this container from scrolling */\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;     /* flex 자식의 기본 min-width:auto 해제 — 자식 ResultGrid 가 부모 폭을 뚫고 가로로 늘어나는 것을 방지. */\r\n    /* padding은 필요에 따라 여기에 두거나 ResultGrid 자체에서 처리 */\r\n}\r\n\r\n/* 이전에 추가했던 .tabDisplayArea 및 내부 .statusLine 관련 스타일은 제거됨 */\r\n\r\n.noTabsMessage {\r\n    padding: 20px;\r\n    text-align: center;\r\n    color: #777;\r\n    font-style: italic;\r\n}\r\n\r\n/* 테이블 정보 탭 내부 스타일 */\r\n.tabContentLoading,\r\n.tabContentError {\r\n    padding: 20px;\r\n    text-align: center;\r\n    font-style: italic;\r\n}\r\n.tabContentError {\r\n    color: red;\r\n}\r\n\r\n.tableDetailContent {\r\n    flex-grow: 1;\r\n    overflow: auto; /* 내용 많을 시 스크롤 */\r\n    padding: 10px; /* 테이블 주변 여백 */\r\n}\r\n\r\n.tableDetailContent h4 {\r\n    margin-top: 0;\r\n    margin-bottom: 10px;\r\n    font-size: 1.1em;\r\n}\r\n\r\n.infoTable {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n    font-size: var(--font-size-grid, 12px);\r\n}\r\n\r\n.infoTable th,\r\n.infoTable td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: left;\r\n    vertical-align: top;\r\n}\r\n\r\n.infoTable th {\r\n    background-color: #f2f2f2;\r\n    font-weight: bold;\r\n}\r\n\r\n.infoTable tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.infoTable tbody tr:hover {\r\n    background-color: #f1f1f1;\r\n}\r\n\r\n/* 실행 계획 탭 컨텐츠 스타일 */\r\n.executionPlanContent {\r\n  padding: 0;\r\n  background-color: #f9f9f9;\r\n  overflow: hidden;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.planTextOutput {\r\n  white-space: pre;\r\n  word-break: normal;\r\n  font-family: var(--font-mono, 'Consolas', monospace);\r\n  font-size: var(--font-size-mono, 13px);\r\n  margin: 0;\r\n  padding: 8px 4px;\r\n}\r\n.planScrollArea {\r\n  padding-top: 4px;\r\n}\r\n\r\n/* 실행계획 인터랙티브 행 */\r\n.planRow {\r\n  cursor: pointer;\r\n  transition: background 0.1s;\r\n  border-radius: 2px;\r\n}\r\n.planRow:hover {\r\n  background: #e3f2fd;\r\n}\r\n.planRowActive {\r\n  background: #bbdefb !important;\r\n  outline: 1px solid #64b5f6;\r\n  outline-offset: -1px;\r\n}\r\n.planRowPredicate {\r\n  /* 왼쪽 선은 **배치에 영향을 주지 않게** 안쪽 그림자로 — border + 음수 margin 은 정확히 상쇄되지 않아\r\n     조건(*) 줄만 글자·구분선이 살짝 밀렸다(화면 확인 2026-10-05) */\r\n  box-shadow: inset 2px 0 0 #ff9800;\r\n}\r\n.planSearchMatch {\r\n  background: rgba(255, 235, 59, 0.25) !important;\r\n}\r\n\r\n.planRowPredicateHighlight {\r\n  background: #fff3e0 !important;\r\n  box-shadow: inset 3px 0 0 #ff9800;   /* border 를 쓰면 그 폭만큼 줄이 오른쪽으로 밀린다 */\r\n  font-weight: 500;\r\n}\r\n\r\n/* 실행계획 좌우 분할 컨테이너 */\r\n.planSplitContainer {\r\n  display: flex !important;\r\n  flex-direction: row !important;\r\n  gap: 0;\r\n  /* 남은 높이만 — height:100% 면 탭 머리줄만큼 넘쳐 계획 맨 아랫줄이 상태 줄 밑으로 잘렸다(신고 2026-10-02) */\r\n  flex: 1 1 0;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n.planLeftPane {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  border-right: 1px solid #e0e0e0;\r\n  position: relative;\r\n}\r\n/* 계획 본문 + 미니맵 — 미니맵은 **이 안에서만** 서서 위 도구 줄(복사·내보내기·보관)을 덮지 않는다.\r\n   예전에는 왼쪽 칸 전체 높이에 떠 있어 맨 오른쪽 「보관」 버튼을 가렸다(신고 2026-10-02) */\r\n.planScrollWrap {\r\n  position: relative;\r\n  flex: 1 1 0;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.planScrollArea {\r\n  flex: 1 1 0;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  padding-right: 46px; /* 미니맵 공간 확보 */\r\n  padding-bottom: 8px; /* 맨 아랫줄이 가장자리에 붙지 않게 */\r\n}\r\n/* 미니맵이 세로 위치를 보여 주고 끌어 옮길 수도 있으니 세로 스크롤바는 감춘다(요청). 가로 스크롤바는 남긴다 */\r\n.planScrollArea::-webkit-scrollbar:vertical { width: 0; }\r\n/* 다크 모드는 모든 요소에 scrollbar-color 를 건다(App.css) — 그러면 Chrome 이 위 웹킷 규칙을 무시해 세로 스크롤바가\r\n   그대로 보였다(2026-10-05). 여기서만 기본값으로 되돌리고 가로 스크롤바 색은 웹킷 규칙으로 준다 */\r\n:global(html) .planScrollArea { scrollbar-color: auto; }\r\n:global([data-theme=\"dark\"]) .planScrollArea::-webkit-scrollbar { background: #1e1e1e; height: 12px; }\r\n:global([data-theme=\"dark\"]) .planScrollArea::-webkit-scrollbar-track { background: #1e1e1e; }\r\n:global([data-theme=\"dark\"]) .planScrollArea::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }\r\n\r\n/* 실행계획 행번호 */\r\n.planLineNum {\r\n  display: inline-block;\r\n  width: 30px;\r\n  text-align: right;\r\n  padding-right: 8px;\r\n  color: #aaa;\r\n  font-size: 0.85em;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n.planLineNum:hover {\r\n  color: #2196f3;\r\n}\r\n.planLineBookmarked {\r\n  color: #2196f3 !important;\r\n}\r\n.planLineBookmarked::before {\r\n  content: '\\25CF ';\r\n  font-size: 8px;\r\n}\r\n.planLineBookmarkedBg {\r\n  background: rgba(33, 150, 243, 0.06);\r\n}\r\n\r\n/* 실행계획 미니맵 — **평소에는 숨고 이 영역에 마우스가 올 때만** 보인다\r\n   (사용자 요청 2026-09-20, 편집기 미니맵 `.sql-editor-minimap.is-idle` 과 같은 규칙).\r\n   편집기는 포커스로 판정하지만 여기는 읽기 전용 `<pre>` 라 포커스가 가지 않아 hover 로 본다.\r\n   자리(`.planScrollArea` 의 padding-right)는 늘 비워 둔다 — 나타날 때 본문이 밀리면\r\n   미니맵을 숨겨 얻은 것보다 눈에 거슬린다. */\r\n.planMinimap {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 40px;\r\n  height: 100%;\r\n  background: rgba(245, 246, 248, 0.85);\r\n  border-left: 1px solid #e0e0e0;\r\n  cursor: pointer;\r\n  z-index: 2;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 160ms ease;\r\n}\r\n.planLeftPane:hover .planMinimap {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n}\r\n.planMinimap:hover {\r\n  background: rgba(238, 240, 244, 0.95);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .planMinimap { transition: none; }\r\n}\r\n.planRightPane {\r\n  flex: 0 0 340px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  background: #fafbfc;\r\n  font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n  font-size: var(--font-size-ui-small, 11px);\r\n  overflow: hidden;\r\n}\r\n.planRightPaneWide {\r\n  flex: 0 0 510px !important;\r\n}\r\n.planRightHeader {\r\n  flex-shrink: 0;\r\n  padding: 6px 8px 0 8px;\r\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\r\n}\r\n.planRightBody {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 8px;\r\n}\r\n.planRightTitle {\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  color: #555;\r\n  padding: 4px 0 8px 0;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  margin-bottom: 8px;\r\n}\r\n.planRightEmpty {\r\n  color: #999;\r\n  font-style: italic;\r\n  text-align: center;\r\n  padding: 20px 0;\r\n}\r\n\r\n/* Predicate 요약 (좌측 하단) */\r\n.predSummary {\r\n  flex-shrink: 0;\r\n  border-top: 1px solid #e0e0e0;\r\n  padding: 8px 10px;\r\n  background: #f5f5f5;\r\n  max-height: 120px;\r\n  overflow-y: auto;\r\n}\r\n.predSummaryTitle {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  color: #555;\r\n  margin-bottom: 4px;\r\n}\r\n.predItem {\r\n  font-size: 11px;\r\n  padding: 3px 6px;\r\n  margin-bottom: 2px;\r\n  border-radius: 3px;\r\n  font-family: monospace;\r\n  word-break: break-all;\r\n}\r\n.predItem code {\r\n  font-size: 11px;\r\n}\r\n.pred_access {\r\n  background: #e8f5e9;\r\n  border-left: 3px solid #4caf50;\r\n}\r\n.pred_filter {\r\n  background: #fff8e1;\r\n  border-left: 3px solid #ff9800;\r\n}\r\n.predType {\r\n  font-weight: 700;\r\n  font-size: 10px;\r\n  text-transform: uppercase;\r\n  margin-right: 6px;\r\n  color: #666;\r\n}\r\n\r\n/* 오브젝트 카드 */\r\n/* 조회 결과에서 뽑은 필터 리본. 켜짐/꺼짐이 색으로 드러나야 토글이라는 것이 읽힌다. */\r\n.objRibbon {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 6px 8px;\r\n    border-bottom: 1px solid var(--color-border, #e5e7eb);\r\n}\r\n\r\n.objRibbonSep {\r\n    width: 1px;\r\n    align-self: stretch;\r\n    margin: 2px 4px;\r\n    background: var(--color-border, #e5e7eb);\r\n}\r\n\r\n.objChip {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 2px 8px;\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 10px;\r\n    background: none;\r\n    color: var(--color-text-secondary, #6b7280);\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    transition: color 150ms ease, border-color 150ms ease, background-color 150ms ease;\r\n}\r\n.objChip:hover { border-color: var(--color-accent, #3b82f6); color: var(--color-accent, #3b82f6); }\r\n\r\n/* 켜진 칩 — 앱의 다른 활성 표시와 같은 강조색 */\r\n.objChipOn {\r\n    border-color: var(--color-accent, #3b82f6);\r\n    color: var(--color-accent, #3b82f6);\r\n    background: var(--color-hover, #eceef1);\r\n    font-weight: 600;\r\n}\r\n\r\n.objChipCount { opacity: 0.7; font-size: 10px; }\r\n\r\n:global([data-theme=\"dark\"]) .objRibbon { border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .objRibbonSep { background: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .objChip { border-color: var(--color-border); color: var(--color-text-secondary); }\r\n:global([data-theme=\"dark\"]) .objChipOn { background: var(--color-hover); }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .objChip { transition: none; }\r\n}\r\n\r\n/* 전체 DDL 버튼 — 카드 머리의 보조 동작이라 테두리만 */\r\n.ddlBtn {\r\n    margin-left: auto;\r\n    padding: 1px 7px;\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 3px;\r\n    background: none;\r\n    color: var(--color-text-secondary, #6b7280);\r\n    font-size: 10px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    transition: color 150ms ease, border-color 150ms ease;\r\n}\r\n.ddlBtn:hover { color: var(--color-accent, #3b82f6); border-color: var(--color-accent, #3b82f6); }\r\n\r\n/* 조립본이라는 사실을 알리는 줄 */\r\n.ddlNote {\r\n    margin: 4px 8px;\r\n    padding: 4px 8px;\r\n    border-radius: 3px;\r\n    background: var(--color-warning-bg, #fef3c7);\r\n    color: var(--color-warning-text, #92400e);\r\n    font-size: 11px;\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .ddlBtn { border-color: var(--color-border); color: var(--color-text-secondary); }\r\n:global([data-theme=\"dark\"]) .ddlNote { background: #78350f; color: #fde68a; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .ddlBtn { transition: none; }\r\n}\r\n\r\n/* 파티션 배지 — 테이블·인덱스 모두 같은 모양. 예전에는 인덱스 쪽만 인라인 스타일이라\r\n   다크에서 밝은 상자로 남았고 「GLOBAL」 만 적혀 무엇의 구분인지 알 수 없었다. */\r\n.partBadge {\r\n    margin-left: 4px;\r\n    padding: 1px 6px;\r\n    border-radius: 3px;\r\n    background: var(--color-bg-tertiary, #e8ecf0);\r\n    color: var(--color-text-secondary, #4b5563);\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n    white-space: nowrap;\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .partBadge {\r\n    background: var(--color-bg-tertiary);\r\n    color: var(--color-text-secondary);\r\n}\r\n\r\n/* 인덱스 생성일시 — 컬럼 목록과 함께 기본으로 보이는 두 가지 중 하나 */\r\n.idxCreated {\r\n    font-size: 10px;\r\n    color: var(--color-text-muted, #9ca3af);\r\n    margin-top: 2px;\r\n}\r\n\r\n/* 상세보기 — 필터가 아니라 **표시 옵션**이라 리본 칩과 모양을 달리한다 */\r\n.objDetailToggle {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    margin-left: auto;\r\n    font-size: 11px;\r\n    color: var(--color-text-secondary, #6b7280);\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .idxCreated { color: var(--color-text-muted); }\r\n:global([data-theme=\"dark\"]) .objDetailToggle { color: var(--color-text-secondary); }\r\n\r\n.objCard {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  margin-bottom: 8px;\r\n  background: #fff;\r\n  transition: box-shadow 0.2s;\r\n}\r\n.objCardHighlight {\r\n  box-shadow: 0 0 0 2px #42a5f5;\r\n  border-color: #42a5f5;\r\n}\r\n.objCardHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 8px;\r\n  background: #f0f4f8;\r\n  border-radius: 6px 6px 0 0;\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n}\r\n.objCardIcon {\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 3px;\r\n  background: #1976d2;\r\n  color: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n.objCardName {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n/* 스키마명은 **작게** — 같은 카드에서 눈이 찾는 것은 테이블명이다 (2026-09-18) */\r\n.objCardSchema {\r\n  font-size: 10px;\r\n  color: var(--color-text-muted, #9ca3af);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* 주석은 이름 오른편에 한 줄로. 자리를 다투면 **주석이 먼저 줄어든다**(이름이 우선이다). */\r\n.objCardComment {\r\n  font-size: 10px;\r\n  color: #888;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.objStatGrid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 2px;\r\n  padding: 4px 8px 6px;\r\n}\r\n.objStatItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 10px;\r\n}\r\n.objStatLabel { color: #888; }\r\n.objStatValue { font-weight: 600; color: #333; }\r\n\r\n/* 인덱스 카드 */\r\n.idxCard {\r\n  margin: 4px 6px 4px 12px;\r\n  padding: 4px 8px;\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 4px;\r\n  background: #fdfdfd;\r\n  transition: box-shadow 0.2s;\r\n}\r\n.idxHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 11px;\r\n}\r\n.idxIcon {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 3px;\r\n  background: #43a047;\r\n  color: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n.idxName {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.idxStatus {\r\n  font-size: 9px;\r\n  color: #888;\r\n  margin-left: auto;\r\n}\r\n.idxCols {\r\n  font-size: 10px;\r\n  color: #1565c0;\r\n  padding: 2px 0 2px 20px;\r\n  font-family: monospace;\r\n}\r\n\r\n/* 쿼리 결과 탭 전체 컨테이너 (기존 subTabsContainer에서 이름 변경 또는 신규) */\r\n.queryResultTabContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* .subTabsContainer 와 같은 이유 — height:100% 는 탭 머리줄만큼 넘쳐 가로 스크롤바가 잘린다 */\r\n    flex: 1 1 0;\r\n    min-height: 0;\r\n    min-width: 0;\r\n}\r\n\r\n/* \"더보기\" 버튼 및 메시지 관련 스타일 */\r\n.fetchMoreContainer {\r\n    padding: 10px;\r\n    text-align: center;\r\n    border-top: 1px solid #eee; /* 결과 그리드와 구분선 */\r\n}\r\n\r\n.fetchMoreButton {\r\n    padding: 8px 16px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n}\r\n\r\n.fetchMoreButton:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.fetchMoreButton:hover:not(:disabled) {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.loadingMessage, \r\n.queryErrorBanner { /* .noMoreDataMessage 제거 또는 다른 스타일 적용 */\r\n    padding: 10px;\r\n    text-align: center;\r\n    font-style: italic;\r\n    color: #555;\r\n    background-color: #f9f9f9;\r\n    border-top: 1px solid #eee;\r\n}\r\n\r\n.loadingMoreIndicator {\r\n    padding: 10px;\r\n    text-align: center;\r\n    font-style: italic;\r\n    color: #007bff; /* 로딩 색상 */\r\n    background-color: #f9f9f9;\r\n    /* border-top: 1px solid #eee; - 필요시 유지 */\r\n    height: 30px; /* 로딩바 공간 확보 (애니메이션 추가 가능) */\r\n}\r\n\r\n/* fetchMoreContainer 및 fetchMoreButton, noMoreDataMessage 스타일은 이제 불필요하므로 제거 */\r\n.fetchMoreContainer,\r\n.fetchMoreButton,\r\n.noMoreDataMessage {\r\n    display: none; /* 완전히 제거 */\r\n}\r\n\r\n.queryErrorBanner {\r\n    background-color: #ffebee; /* 옅은 빨간색 배경 */\r\n    color: #c62828; /* 어두운 빨간색 텍스트 */\r\n    font-style: normal;\r\n    border-bottom: 1px solid #ffcdd2; /* 빨간색 계열 테두리 */\r\n    border-top: none; /* 위쪽 테두리는 보통 subTabsHeader가 처리 */\r\n    margin-bottom: 5px; /* ResultGrid와의 간격 */\r\n}\r\n\r\n/* 오류는 왼쪽 정렬로, 코드마다 한 줄(utils/errorLines). 길면 배너 안에서 스크롤 — 결과 칸을 밀어내지 않는다 */\r\n.queryErrorBanner { display: flex; align-items: flex-start; gap: 8px; text-align: left; padding: 8px 12px; max-height: 40%; overflow-y: auto; flex-shrink: 0; }\r\n.queryErrorBanner strong { flex: 0 0 auto; }\r\n.queryErrorLines { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 2px; overflow-wrap: anywhere; line-height: 1.5; user-select: text; }\r\n.queryErrorMain { font-weight: 600; }\r\n.queryErrorTrace { font-family: Consolas, 'Nanum Gothic Coding', monospace; font-size: 0.92em; opacity: 0.8; }\r\n\r\n.queryErrorBanner strong {\r\n    font-weight: bold;\r\n}\r\n\r\n/* 다크모드 — 에러 배너: 채도 낮춘 빨강 배경 + 밝은 빨강 텍스트 */\r\n:global([data-theme=\"dark\"]) .queryErrorBanner {\r\n    background-color: rgba(220, 53, 69, 0.18);\r\n    color: #ff8a80;\r\n    border-bottom-color: rgba(220, 53, 69, 0.4);\r\n}\r\n:global([data-theme=\"dark\"]) .queryErrorBanner strong {\r\n    color: #ffb4b4;\r\n}\r\n:global([data-theme=\"dark\"]) .queryErrorBanner a {\r\n    color: #ffb4b4;\r\n}\r\n\r\n/* ======== 다크모드 ======== */\r\n:global([data-theme=\"dark\"]) .subTabsContainer {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .subTabsHeader {\r\n  background: var(--color-bg-tertiary);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .subTabButton {\r\n  color: var(--color-text-muted);\r\n}\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer.active .subTabButton {\r\n  color: var(--color-text);\r\n  background: var(--color-bg);\r\n}\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer {\r\n  background: var(--color-bg-tertiary);\r\n  color: var(--color-text-muted);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer.active {\r\n  background: var(--color-bg);\r\n  color: var(--color-text);\r\n  border-color: var(--color-border);\r\n  border-bottom-color: var(--color-bg);\r\n}\r\n:global([data-theme=\"dark\"]) .executionPlanContent {\r\n  background: var(--color-bg);\r\n}\r\n:global([data-theme=\"dark\"]) .planTextOutput {\r\n  color: var(--color-text);\r\n}\r\n:global([data-theme=\"dark\"]) .planLeftPane {\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .planRightPane {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text);\r\n}\r\n:global([data-theme=\"dark\"]) .planRightTitle {\r\n  color: var(--color-text-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .objCard {\r\n  background: var(--color-bg-tertiary);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .objCardHeader {\r\n  background: var(--color-bg-secondary);\r\n}\r\n:global([data-theme=\"dark\"]) .idxCard {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .predSummary {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .planRow:hover {\r\n  background: var(--color-hover);\r\n}\r\n:global([data-theme=\"dark\"]) .planRowActive {\r\n  background: #264f78 !important;\r\n  outline-color: var(--color-accent-fg);\r\n}\r\n:global([data-theme=\"dark\"]) .planMinimap {\r\n  background: rgba(37,37,38,0.85);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .planRowPredicateHighlight {\r\n  background: rgba(255, 152, 0, 0.2) !important;\r\n  box-shadow: inset 3px 0 0 #ffb74d;\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .planSearchMatch {\r\n  background: rgba(255, 235, 59, 0.15) !important;\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .pred_access {\r\n  background: rgba(76, 175, 80, 0.2);\r\n  border-left-color: #81c784;\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .pred_filter {\r\n  background: rgba(255, 152, 0, 0.2);\r\n  border-left-color: #ffb74d;\r\n}\r\n:global([data-theme=\"dark\"]) .planLineNum {\r\n  color: var(--color-text-muted);\r\n}\r\n:global([data-theme=\"dark\"]) .noTabsMessage {\r\n  color: var(--color-text-muted);\r\n}\r\n:global([data-theme=\"dark\"]) .subTabsContent {\r\n  background: var(--color-bg);\r\n}\r\n:global([data-theme=\"dark\"]) .infoTable {\r\n  background: var(--color-bg);\r\n}\r\n:global([data-theme=\"dark\"]) .infoTable th {\r\n  background: var(--color-bg-tertiary);\r\n  color: var(--color-text);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .infoTable td {\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n  background: var(--color-bg);\r\n}\r\n:global([data-theme=\"dark\"]) .infoTable tbody tr:nth-child(even) td {\r\n  background: var(--color-bg-secondary);\r\n}\r\n:global([data-theme=\"dark\"]) .infoTable tbody tr:hover td {\r\n  background: var(--color-hover);\r\n}\r\n:global([data-theme=\"dark\"]) .closeTabButton {\r\n  color: var(--color-text-muted);\r\n} :global([data-theme=\"dark\"]) .mainTabButton { color: var(--color-text-muted) !important; border-color: var(--color-border) !important; }\r\n:global([data-theme=\"dark\"]) .mainTabButton.active,\r\n:global([data-theme=\"dark\"]) .activeMainTab { background: var(--color-bg) !important; color: var(--color-text) !important; border-bottom-color: var(--color-accent-fg) !important; }\r\n\r\n:global([data-theme=\"dark\"]) .mainTabsContentArea,\r\n:global([data-theme=\"dark\"]) .queryResultTabContainer,\r\n:global([data-theme=\"dark\"]) .subTabsContainer {\r\n  background: var(--color-bg) !important;\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .mainTabsSidebar,\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer {\r\n  background: var(--color-bg-secondary) !important;\r\n  border-right-color: var(--color-border) !important;\r\n}\r\n:global([data-theme=\"dark\"]) .tabActionsArea {\r\n  background: var(--color-bg-secondary) !important;\r\n  border-left-color: var(--color-border) !important;\r\n}\r\n:global([data-theme=\"dark\"]) .mainTabButton:hover { background: var(--color-hover) !important; }\r\n:global([data-theme=\"dark\"]) .closeTabButton:hover { color: #ff6b6b !important; }\r\n:global([data-theme=\"dark\"]) .planSearchMatch { background: rgba(255,235,59,0.1) !important; }\r\n:global([data-theme=\"dark\"]) .mainTabsSidebar { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }\r\n:global([data-theme=\"dark\"]) .queryResultTabContainer { background: var(--color-bg) !important; }\r\n/* 탭이 없을 때의 안내 — 머리말 위에 밝은 상자·밝은 테두리(#ddd)로 떠 보이지 않게 */\r\n:global([data-theme=\"dark\"]) .subTabButtonPlaceholder { background: transparent !important; color: var(--color-text-muted); }\r\n:global([data-theme=\"dark\"]) .tabActionsArea { background: var(--color-bg-secondary) !important; }\r\n:global([data-theme=\"dark\"]) .tabButtonsArea { background: var(--color-bg-secondary) !important; }\r\n\r\n/* Table Info CSS / Predicate Item Dark Mode */\r\n:global([data-theme=\"dark\"]) .objStatItem { color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .objStatLabel { color: var(--color-text-muted); }\r\n:global([data-theme=\"dark\"]) .objStatValue { color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .objCardComment { color: var(--color-text-muted); }\r\n:global([data-theme=\"dark\"]) .idxName { color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .idxCols { color: #6cb6ff; }\r\n:global([data-theme=\"dark\"]) .idxStatus { color: var(--color-text-muted); }\r\n\r\n:global([data-theme=\"dark\"]) .predSummaryTitle { color: var(--color-text-secondary); }\r\n:global([data-theme=\"dark\"]) .predItem { color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .predItem code { color: #89b4fa; }\r\n:global([data-theme=\"dark\"]) .pred_access { background: rgba(76, 175, 80, 0.15); border-left-color: #4caf50; }\r\n:global([data-theme=\"dark\"]) .pred_filter { background: rgba(255, 152, 0, 0.15); border-left-color: #ff9800; }\r\n:global([data-theme=\"dark\"]) .predType { color: var(--color-text-muted); }\r\n\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer { background: var(--color-bg-tertiary) !important; }\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer.active { background: var(--color-bg) !important; border-bottom-color: var(--color-bg) !important; }\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer.active .subTabButton { color: var(--color-text) !important; }\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer:not(.active) .subTabButton { color: var(--color-text-muted) !important; }\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer.active:hover { background: var(--color-bg) !important; }\r\n:global([data-theme=\"dark\"]) .subTabButtonContainer:not(.active):hover { background: var(--color-hover) !important; }\r\n:global([data-theme=\"dark\"]) .closeTabButton { background: transparent !important; color: var(--color-text-muted) !important; }\r\n:global([data-theme=\"dark\"]) .closeTabButton:hover { color: #ff6b6b !important; background: rgba(255,107,107,0.15) !important; }\r\n:global([data-theme=\"dark\"]) .kindPinButton:hover { background: var(--color-hover); }\r\n:global([data-theme=\"dark\"]) .stopTabButton { color: var(--color-text) !important; }\r\n:global([data-theme=\"dark\"]) .planRightHeader { border-color: var(--color-border) !important; }\r\n:global([data-theme=\"dark\"]) .planRightBody { background: var(--color-bg-secondary) !important; }\r\n\r\n/* 실행 중 탭의 로딩 스피너 */\r\n.subTabSpinner {\r\n  animation: subTabSpinnerRotate 1s linear infinite;\r\n  color: var(--color-text-muted, #6b7280);\r\n}\r\n@keyframes subTabSpinnerRotate {\r\n  from { transform: rotate(0deg); }\r\n  to   { transform: rotate(360deg); }\r\n}\r\n\r\n/* 실행 중 — 결과 영역 본문.\r\n   빈 결과(0건)와 **아직 안 끝난 것**을 눈으로 구분할 수 있어야 한다. */\r\n.runningMessage {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  color: var(--color-text-muted, #6b7280);\r\n  font-style: italic;\r\n  animation: runningFadeIn 160ms ease-out;\r\n}\r\n.runningSpinner {\r\n  width: 14px;\r\n  height: 14px;\r\n  border: 2px solid var(--color-border, #d1d5db);\r\n  border-top-color: var(--color-primary, #3b82f6);\r\n  border-radius: 50%;\r\n  animation: subTabSpinnerRotate 1s linear infinite;\r\n}\r\n@keyframes runningFadeIn {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .runningMessage { animation: none; }\r\n  .runningSpinner { animation: none; }\r\n}\r\n\r\n/* 계획 탭의 도구줄 — 검색 + 복사·내보내기·보관.\r\n   이 계획 하나에만 작용하는 것들이라 메뉴가 아니라 대상 가까이 둔다\r\n   (docs/ui-command-placement.md 규칙 4). */\r\n.planToolRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n  flex-wrap: wrap;\r\n}\r\n.planToolBtns {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  margin-left: auto;\r\n  padding-right: 6px;\r\n}\r\n.planToolBtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 3px 8px;\r\n  border: 1px solid var(--color-border, #d0d5dd);\r\n  border-radius: 3px;\r\n  background: var(--color-bg, #fff);\r\n  color: var(--color-text, #1f2937);\r\n  font-size: 11px;\r\n  font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\r\n}\r\n.planToolBtn:hover {\r\n  border-color: var(--color-accent, #3b82f6);\r\n  color: var(--color-accent, #3b82f6);\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .planToolBtn {\r\n  background: transparent;\r\n  color: var(--color-text);\r\n  border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .planToolBtn:hover {\r\n  background: var(--color-hover);\r\n  border-color: var(--color-accent-fg);\r\n  color: var(--color-accent-fg);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .planToolBtn { transition: none; }\r\n}\r\n\r\n/* 실행계획 본문의 넓은 글자(한글 등) - 정확히 고정폭 2칸. 고정폭 글꼴에 한글이 없으면 대체 글꼴의 한글이 2칸보다 넓어\r\n   한글이 든 줄만 뒤가 밀렸다(utils/monoWide.js, 2026-10-05) */\r\n.wideCh {\r\n  display: inline-block;\r\n  width: 2ch;\r\n  text-align: center;\r\n  overflow: hidden;\r\n  vertical-align: bottom;\r\n}\r\n\r\n/* SQL Monitor 리포트 — 실행계획 아래에 접어서(2026-10-07). 펼치면 이 칸만 스크롤한다 */\r\n.monitorReport {\r\n  flex-shrink: 0;\r\n  border-top: 1px solid var(--color-border, #e0e0e0);\r\n  font-size: 11px;\r\n}\r\n.monitorReport > summary {\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  user-select: none;\r\n}\r\n.monitorReport > pre {\r\n  margin: 0;\r\n  max-height: 260px;\r\n  overflow: auto;\r\n  padding: 6px 10px 10px;\r\n  font-family: 'Consolas', 'Monaco', monospace;\r\n  font-size: 11px;\r\n  line-height: 1.45;\r\n  white-space: pre;\r\n  animation: monitorReportIn 160ms ease-out;\r\n}\r\n@keyframes monitorReportIn {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .monitorReport > pre { animation: none; }\r\n}\r\n\r\n/* ── 결과 탭 머리줄은 배경 한 장(2026-10-07, 사용자 요청) ──\r\n   다크에서 머리줄(#2d2d2d)과 탭·버튼 영역(#252526)의 색이 달라 머리줄 위 여백(5px)·오른쪽 여백이 굵은 선처럼 보였다.\r\n   머리줄이 색을 정하고 안쪽 영역은 투명으로 둔다. 아래 경계선은 1px 한 줄 — 그리드 쪽 테두리는 없앴다(App.css). */\r\n:global([data-theme=\"dark\"]) .subTabsHeader { background-color: var(--color-bg-secondary) !important; }\r\n:global([data-theme=\"dark\"]) .tabActionsArea,\r\n:global([data-theme=\"dark\"]) .tabButtonsArea { background: transparent !important; }\r\n\r\n/* 오브젝트 상세 — 인덱스는 개수만 보이다가 누르면 펼친다 */\r\n.idxToggle { display: inline-flex; align-items: center; gap: 4px; margin: 4px 0 2px 8px; padding: 1px 8px; border: 1px solid var(--color-border, #d1d5db); border-radius: 10px; background: transparent; color: inherit; font-size: 11px; cursor: pointer; transition: background-color 150ms ease, border-color 150ms ease; }\r\n.idxToggle:hover { border-color: var(--color-accent, #3b82f6); background: rgba(59, 130, 246, 0.08); }\r\n.idxToggleArrow { font-size: 9px; opacity: 0.7; }\r\n@media (prefers-reduced-motion: reduce) { .idxToggle { transition: none; } }\r\n\r\n/* 실행 중인 문장의 모니터링 — 중지 단추 옆 */\r\n.monitorTabButton { white-space: nowrap; flex-shrink: 0; background: transparent; border: 1px solid var(--color-accent, #3b82f6); color: var(--color-accent, #3b82f6); cursor: pointer; font-size: 11px; font-weight: 500; padding: 3px 9px; margin-left: 4px; border-radius: 3px; transition: background-color 150ms ease, color 150ms ease; }\r\n.monitorTabButton:hover { background: var(--color-accent, #3b82f6); color: #fff; }\r\n@media (prefers-reduced-motion: reduce) { .monitorTabButton { transition: none; } }\r\n\r\n/* 테이블 정보(F4) — 하위 탭은 나란히, 표는 결과 그리드처럼 촘촘하게(2026-10-28 신고: 글자가 크고 인덱스 목록이 밀려 안 보였다) */\r\n.infoSubTabs {\r\n    justify-content: flex-start;\r\n    gap: 2px;\r\n}\r\n.infoSubTabs .subTabButton {\r\n    border-bottom: 2px solid transparent;\r\n    color: var(--color-text-secondary, #666);\r\n    transition: color 150ms ease, border-color 150ms ease;\r\n}\r\n.infoSubTabs .subTabButton.active {\r\n    color: var(--color-accent, #2563eb);\r\n    border-bottom-color: var(--color-accent, #2563eb);\r\n    font-weight: 600;\r\n}\r\n.infoTableCompact {\r\n    font-size: var(--font-size-ui-small, 11px);\r\n}\r\n.infoTableCompact th,\r\n.infoTableCompact td {\r\n    padding: 3px 8px;\r\n    line-height: 1.4;\r\n}\r\n.infoTableCompact th {\r\n    white-space: nowrap;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1;\r\n}\r\n.subTabsContainer .tableDetailContent {\r\n    padding: 6px 8px;\r\n    animation: info-fade 150ms ease-out;\r\n}\r\n.subTabsContainer .tableDetailContent h4 {\r\n    font-size: 12px;\r\n    margin-bottom: 6px;\r\n}\r\n@keyframes info-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\r\n@media (prefers-reduced-motion: reduce) {\r\n    .subTabsContainer .tableDetailContent { animation: none; }\r\n    .infoSubTabs .subTabButton { transition: none; }\r\n}\r\n\r\n/* 오브젝트 탭 이름 — 스키마는 작게, 전체 폭은 제한하고 넘치면 「…」(전체 이름은 툴팁) — 2026-10-29 요청 */\r\n.tabNameObject {\r\n    display: inline-flex;\r\n    align-items: baseline;\r\n    max-width: 180px;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n}\r\n.tabNameSchema {\r\n    flex-shrink: 1;\r\n    min-width: 0;\r\n    max-width: 70px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    font-size: 0.85em;\r\n    opacity: 0.75;\r\n}\r\n.tabNameTable {\r\n    flex-shrink: 1;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainDisplayTabsContainer": `MainDisplayTabs_mainDisplayTabsContainer__1xZmM`,
	"subTabKindIcon": `MainDisplayTabs_subTabKindIcon__e3ee3`,
	"subTabButtonContainer": `MainDisplayTabs_subTabButtonContainer__GAjBB`,
	"active": `MainDisplayTabs_active__JsB9V`,
	"mainTabsContentArea": `MainDisplayTabs_mainTabsContentArea__oixj8`,
	"tabContent": `MainDisplayTabs_tabContent__n-Lr6`,
	"subTabsContainer": `MainDisplayTabs_subTabsContainer__SPQfO`,
	"subTabsHeader": `MainDisplayTabs_subTabsHeader__zYO8K`,
	"tabButtonsArea": `MainDisplayTabs_tabButtonsArea__tbty6`,
	"tabActionsArea": `MainDisplayTabs_tabActionsArea__AT5mr`,
	"actionButton": `MainDisplayTabs_actionButton__qul1G`,
	"stopButton": `MainDisplayTabs_stopButton__qE9ey`,
	"subTabButton": `MainDisplayTabs_subTabButton__W5txA`,
	"kindPinButton": `MainDisplayTabs_kindPinButton__5qxvO`,
	"pinned": `MainDisplayTabs_pinned__3yBs-`,
	"stopTabButton": `MainDisplayTabs_stopTabButton__m+o73`,
	"closeTabButton": `MainDisplayTabs_closeTabButton__xK0+i`,
	"subTabButtonPlaceholder": `MainDisplayTabs_subTabButtonPlaceholder__W1m+Q`,
	"subTabsContent": `MainDisplayTabs_subTabsContent__pyW55`,
	"noTabsMessage": `MainDisplayTabs_noTabsMessage__YSKFA`,
	"tabContentLoading": `MainDisplayTabs_tabContentLoading__spxjb`,
	"tabContentError": `MainDisplayTabs_tabContentError__lKrBq`,
	"tableDetailContent": `MainDisplayTabs_tableDetailContent__e2M5F`,
	"infoTable": `MainDisplayTabs_infoTable__zX80K`,
	"executionPlanContent": `MainDisplayTabs_executionPlanContent__sBTJ3`,
	"planTextOutput": `MainDisplayTabs_planTextOutput__UVtIz`,
	"planScrollArea": `MainDisplayTabs_planScrollArea__J1ism`,
	"planRow": `MainDisplayTabs_planRow__SoxSy`,
	"planRowActive": `MainDisplayTabs_planRowActive__W0Dn3`,
	"planRowPredicate": `MainDisplayTabs_planRowPredicate__GYuaK`,
	"planSearchMatch": `MainDisplayTabs_planSearchMatch__kch6b`,
	"planRowPredicateHighlight": `MainDisplayTabs_planRowPredicateHighlight__4ctzN`,
	"planSplitContainer": `MainDisplayTabs_planSplitContainer__7lfUO`,
	"planLeftPane": `MainDisplayTabs_planLeftPane__Fms8C`,
	"planScrollWrap": `MainDisplayTabs_planScrollWrap__4Aw60`,
	"planLineNum": `MainDisplayTabs_planLineNum__5pjjA`,
	"planLineBookmarked": `MainDisplayTabs_planLineBookmarked__R2MCX`,
	"planLineBookmarkedBg": `MainDisplayTabs_planLineBookmarkedBg__dTsu1`,
	"planMinimap": `MainDisplayTabs_planMinimap__346Jk`,
	"planRightPane": `MainDisplayTabs_planRightPane__gB9P3`,
	"planRightPaneWide": `MainDisplayTabs_planRightPaneWide__COAsC`,
	"planRightHeader": `MainDisplayTabs_planRightHeader__W04tV`,
	"planRightBody": `MainDisplayTabs_planRightBody__Edr-m`,
	"planRightTitle": `MainDisplayTabs_planRightTitle__Ho3Yp`,
	"planRightEmpty": `MainDisplayTabs_planRightEmpty__zgUdX`,
	"predSummary": `MainDisplayTabs_predSummary__B4sb-`,
	"predSummaryTitle": `MainDisplayTabs_predSummaryTitle__LrTiy`,
	"predItem": `MainDisplayTabs_predItem__wWy9Z`,
	"pred_access": `MainDisplayTabs_pred_access__cbnNH`,
	"pred_filter": `MainDisplayTabs_pred_filter__natSE`,
	"predType": `MainDisplayTabs_predType__XwKEX`,
	"objRibbon": `MainDisplayTabs_objRibbon__ILa05`,
	"objRibbonSep": `MainDisplayTabs_objRibbonSep__WXgl6`,
	"objChip": `MainDisplayTabs_objChip__5rIwf`,
	"objChipOn": `MainDisplayTabs_objChipOn__0OXw0`,
	"objChipCount": `MainDisplayTabs_objChipCount__LakVB`,
	"ddlBtn": `MainDisplayTabs_ddlBtn__3+9Vs`,
	"ddlNote": `MainDisplayTabs_ddlNote__H-B1g`,
	"partBadge": `MainDisplayTabs_partBadge__KMKMc`,
	"idxCreated": `MainDisplayTabs_idxCreated__MJYpR`,
	"objDetailToggle": `MainDisplayTabs_objDetailToggle__7lXVo`,
	"objCard": `MainDisplayTabs_objCard__DPsap`,
	"objCardHighlight": `MainDisplayTabs_objCardHighlight__nPRfd`,
	"objCardHeader": `MainDisplayTabs_objCardHeader__crLoo`,
	"objCardIcon": `MainDisplayTabs_objCardIcon__+fYZp`,
	"objCardName": `MainDisplayTabs_objCardName__wkL7E`,
	"objCardSchema": `MainDisplayTabs_objCardSchema__dKw9b`,
	"objCardComment": `MainDisplayTabs_objCardComment__5hShp`,
	"objStatGrid": `MainDisplayTabs_objStatGrid__XVg-t`,
	"objStatItem": `MainDisplayTabs_objStatItem__bCL9r`,
	"objStatLabel": `MainDisplayTabs_objStatLabel__ZmLb7`,
	"objStatValue": `MainDisplayTabs_objStatValue__iBZYu`,
	"idxCard": `MainDisplayTabs_idxCard__bqv4I`,
	"idxHeader": `MainDisplayTabs_idxHeader__FL7PF`,
	"idxIcon": `MainDisplayTabs_idxIcon__d+Dlr`,
	"idxName": `MainDisplayTabs_idxName__GQhvB`,
	"idxStatus": `MainDisplayTabs_idxStatus__yJxcv`,
	"idxCols": `MainDisplayTabs_idxCols__3Gsnj`,
	"queryResultTabContainer": `MainDisplayTabs_queryResultTabContainer__35COb`,
	"fetchMoreContainer": `MainDisplayTabs_fetchMoreContainer__K2rGq`,
	"fetchMoreButton": `MainDisplayTabs_fetchMoreButton__sYMW-`,
	"loadingMessage": `MainDisplayTabs_loadingMessage__NA3ta`,
	"queryErrorBanner": `MainDisplayTabs_queryErrorBanner__c1Aln`,
	"loadingMoreIndicator": `MainDisplayTabs_loadingMoreIndicator__yS6+W`,
	"noMoreDataMessage": `MainDisplayTabs_noMoreDataMessage__0XKzS`,
	"queryErrorLines": `MainDisplayTabs_queryErrorLines__lY9zj`,
	"queryErrorMain": `MainDisplayTabs_queryErrorMain__My4ba`,
	"queryErrorTrace": `MainDisplayTabs_queryErrorTrace__bAKJ0`,
	"mainTabButton": `MainDisplayTabs_mainTabButton__uU+z7`,
	"activeMainTab": `MainDisplayTabs_activeMainTab__JiqgL`,
	"mainTabsSidebar": `MainDisplayTabs_mainTabsSidebar__ZSMLg`,
	"subTabSpinner": `MainDisplayTabs_subTabSpinner__y-fpv`,
	"subTabSpinnerRotate": `MainDisplayTabs_subTabSpinnerRotate__v7djF`,
	"runningMessage": `MainDisplayTabs_runningMessage__ox+aB`,
	"runningFadeIn": `MainDisplayTabs_runningFadeIn__uaPRx`,
	"runningSpinner": `MainDisplayTabs_runningSpinner__98dyj`,
	"planToolRow": `MainDisplayTabs_planToolRow__ifcE5`,
	"planToolBtns": `MainDisplayTabs_planToolBtns__r1ooV`,
	"planToolBtn": `MainDisplayTabs_planToolBtn__BKXoe`,
	"wideCh": `MainDisplayTabs_wideCh__EbqRR`,
	"monitorReport": `MainDisplayTabs_monitorReport__rtqp+`,
	"monitorReportIn": `MainDisplayTabs_monitorReportIn__+wuhi`,
	"idxToggle": `MainDisplayTabs_idxToggle__kq7aP`,
	"idxToggleArrow": `MainDisplayTabs_idxToggleArrow__LPP+d`,
	"monitorTabButton": `MainDisplayTabs_monitorTabButton__Hj-ML`,
	"infoSubTabs": `MainDisplayTabs_infoSubTabs__L1Cr4`,
	"infoTableCompact": `MainDisplayTabs_infoTableCompact__uLpVE`,
	"info-fade": `MainDisplayTabs_info-fade__JH22l`,
	"tabNameObject": `MainDisplayTabs_tabNameObject__lIPiR`,
	"tabNameSchema": `MainDisplayTabs_tabNameSchema__NkHnT`,
	"tabNameTable": `MainDisplayTabs_tabNameTable__cCdz5`
};
export default ___CSS_LOADER_EXPORT___;
